<template>
 
  <div>
    <v-fab-transition>
      <v-btn
        class="fab-multiple"
        fab
        dark
        large
        color="primary"
        fixed
        right
        bottom
        v-show="multipleSelectedItem"
        @click="addMultipleItem"
      >
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-fab-transition>

    <share-link
      :dialog="shareLinkDialog"
      @close="close"
      :generatedURL="generatedURL"
    />

    <confirmation-dialog
      @confirmed="save"
      :onSetConfirmedDialog="setConfirmedDialog"
      :confirmedDialog="$store.state.services.confirmedDialog"
      :title="title"
      :content="content"
    />

    <v-dialog v-model="skinDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Confirming... </v-card-title>
        <v-card-text
          >Service Item require body check, do you want to add
          images?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeDialog(true)">
            Yes
          </v-btn>
          <v-btn color="green darken-1" text @click="closeDialog(false)">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SkinCheckImageUploadDialog
      @openDialog="openSkinCheckImageUploadDialog"
      ref="skin"
    />

    <ViewSkinCheckImages
      @openDialog="openServicePlanAttachmentsDialog"
      ref="attachments"
    />

    <div class="text-center">
      <v-overlay :value="isSaving">
        <v-container style="height: 400px">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              Saving...
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                color="deep-purple accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
      </v-overlay>
    </div>
    <v-snackbar v-model="msg" :color="color" top :vertical="true">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark color="white" text v-bind="attrs" @click="msg = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-fab-transition>
      <v-btn
        fab
        dark
        large
        color="primary"
        fixed
        right
        bottom
        v-show="multipleSelectedItem"
        @click="addMultipleItem"
      >
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-card outlined tile height="100%">
      <v-expansion-panels class="overflow-y-auto" max-height="640">
        <!-- MORNING  -->
        <v-expansion-panel hide-actions v-show="morningServices.length > 0" >
            <v-expansion-panel-header class="panel-header" @click="handleChangePanel('morning')">
              <template v-slot:actions>
                <v-progress-circular
                  :value="service.morning.progress"
                  :color="service.morning.incomplete ? 'red' : 'success'"
                >
                  <v-icon
                    :color="service.morning.incomplete ? 'red' : 'success'"
                    small
                  >
                    {{
                      service.morning.progress === 100
                        ? "mdi-check"
                        : "mdi-medical-bag"
                    }}
                  </v-icon>
                </v-progress-circular>
              </template>

              <v-row align="center" justify="center" no-gutters>
                <v-col cols="12" sm="12" md="4" class="my-1">
                  <v-row>
                    <v-col cols="4" sm="4" md="2" class="hidden-sm-and-down">
                      <v-avatar size="36px">
                        <v-icon color="teal">mdi-medical-bag</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="10" class="my-1">
                      <div class="pa-2 d-flex justify-center">
                        <strong>{{ schedule.morning }} ADL's</strong>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" sm="12" md="8">
                  <v-row wrap>
                    <v-col cols="12" sm="12" md="12">
                      <div class="d-flex justify-center pa-1">
                        <v-row class="justify-center justify-md-start">
                          <v-chip
                            :color="
                              service.morning.incomplete
                                ? 'red lighten-4'
                                : 'success lighten-4'
                            "
                            class="ml-0 mx-1 black--text my-1"
                            label
                            small
                          >
                            {{
                              service.morning.incomplete
                                ? "INCOMPLETE"
                                : "COMPLETE"
                            }}
                          </v-chip>

                          <v-chip
                            color="teal lighten-4"
                            class="ml-0 black--text my-1"
                            label
                            small
                          >
                            <span class="text-overline"
                              >{{ service.morning.completed }} /
                              {{ service.morning.total }} ADL’s completed</span
                            >
                          </v-chip>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-item-group multiple>
                <v-container fluid class="pa-0">
                  <v-row>
                    <!-- LIST OF ADL -->
                    <v-col
                      cols="12"
                      lg="4"
                      sm="6"
                      v-for="(serv, index) in morningServices.filter(
                        (item) => item.isSigned != true
                      )"
                      :key="index"
                      :class="defaultMargin"
                    >
                      <v-item v-slot="{ active, toggle }">
                        <v-card
                          min-height="100%"
                          id="ADLCard"
                          :color="active ? 'blue lighten-5' : ''"
                        >
                          <v-toolbar dark color="primary" dense>
                            <v-toolbar-title>
                              <v-card-title class="body-2">
                                {{ serv.ServiceItem }} - {{ serv.Type }}
                              </v-card-title>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                              <div class="mr-n3" style="margin-top: 10px">
                                <v-checkbox
                                  @click="
                                    toggle();
                                    selectedItem({ ...serv, active: !active });
                                  "
                                ></v-checkbox>
                              </div>
                            </v-toolbar-items>
                          </v-toolbar>

                          <v-container
                            class="fill-height ma-0 pa-0 img-container"
                            fluid
                          >
                            <div class="overlay-fade ma-0 pa-0">
                              <v-chip
                                class="ma-2 schedule-time darken-4"
                                color="blue"
                                label
                                text-color="white"
                              >
                                <v-icon left> mdi-clock </v-icon>
                                {{ serv.newScheduledTime }}
                              </v-chip>
                              <v-chip
                                v-if="!isAuditorRole"
                                @click="openSkinCheckImageUploadDialog(serv)"
                                v-show="isBodyCheck(serv)"
                                class="btn-image-upload darken-4"
                                color="blue"
                                label
                                text-color="white"
                              >
                                <v-icon left>mdi-cloud-upload</v-icon>
                                Upload
                              </v-chip>
                              <v-chip
                                v-if="!isAuditorRole"
                                @click="openServicePlanAttachmentsDialog(serv)"
                                v-show="isBodyCheck(serv)"
                                class="btn-view-image darken-4"
                                color="blue"
                                label
                                text-color="white"
                              >
                                <v-icon left>grid_view</v-icon>
                                View All Images
                              </v-chip>
                              <v-chip
                                v-if="!isAuditorRole"
                                v-show="
                                 isBodyCheck(serv) &&
                                  selectedInjuryItem === 'Yes'
                                "
                                class="btn-follow-up darken-4"
                                color="blue"
                                text-color="white"
                              >
                                <v-select
                                  :items="followUpItems"
                                  @change="selectFollowUpItem"
                                  placeholder="You want to Follow Up?"
                                  dense
                                  outlined
                                ></v-select>
                              </v-chip>
                              <v-chip
                                v-if="!isAuditorRole"
                                v-show="isBodyCheck(serv) && selectedInjuryItem === 'Yes'"
                                @click="openCreateIncidentReportDialog(serv)"
                                class="btn-incident-report darken-4"
                                color="blue"
                                text-color="white"
                              >
                                <v-icon left>mdi-pencil</v-icon>
                                Create Incident Report
                              </v-chip>
                              <span class="shared-link">
                                <v-icon
                                  @click="createShareLink(serv)"
                                  class="mr-3 my-n5"
                                  color="white"
                                >
                                  mdi-share-variant
                                </v-icon>
                              </span>
                              <img
                                v-if="!isBodyCheck(serv)"
                                :src="serv.ImageUrl"
                                class="adl-image"
                              />
                              <img
                                v-else
                                :src="serv.Attachments[0]"
                                class="adl-image"
                              />
                              <div></div>
                            </div>

                            <p class="description ma-2 pa-2 text-body2">
                              <span v-if="serv.reveal">{{
                                serv.Description.substring(0, 150)
                              }}</span>
                              <span
                                v-if="serv.Description.length >= 150"
                                @click="readMore(index, serv)"
                              >
                                <a
                                  class="caption white--text"
                                  v-if="serv.reveal"
                                  >...Read More
                                </a>
                              </span>

                              <v-divider></v-divider>

                              <v-expand-transition>
                                <v-card
                                  v-if="reveal && cardIndex === index"
                                  class="transition-fast-in-fast-out v-card--reveal"
                                  style="height: 500"
                                >
                                  <v-card-text class="pb-0">
                                    <p>{{ serv.Description }}</p>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-list-item class="grow">
                                      <v-row justify="end">
                                        <v-btn
                                          text
                                          color="primary accent-4"
                                          @click="onReveal(serv)"
                                        >
                                          Close
                                        </v-btn>
                                      </v-row>
                                    </v-list-item>
                                  </v-card-actions>
                                </v-card>
                              </v-expand-transition>
                            </p>
                          </v-container>

                        <validation-observer ref="morningObserver">
                          <v-row dense class="ma-3">
                            <v-col cols="12" sm="6">
                              <v-select
                                v-show="
                                  active && !isBodyCheck(serv)
                                "
                                label="Assistance"
                                outlined
                                v-model="newAssistance"
                                :items="assistance"
                                hide-details
                              >
                              </v-select>
                              <v-select
                                v-show="
                                  !active && !isBodyCheck(serv)
                                "
                                label="Assistance"
                                outlined
                                v-model="serv.LOA"
                                :items="assistance"
                                hide-details
                              >
                              </v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-select
                                v-show="active"
                                label="Exception"
                                v-model="newException"
                                outlined
                                height="10"
                                :items="exception"
                                clearable
                                hide-details
                              ></v-select>
                              <v-select
                                v-show="!active"
                                label="Exception"
                                v-model="serv.newException"
                                outlined
                                height="10"
                                :items="exception"
                                clearable
                                hide-details
                              ></v-select>
                            </v-col>
                          </v-row>

                          <v-row class="ma-3">
                            <v-col cols="12" sm="12" class="pa-1">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Notes"
                                rules="required"
                              >
                                <v-textarea
                                  v-show="active"
                                  label="Add Notes"
                                  v-model="newNotes"
                                  outlined
                                  auto-grow
                                  hide-details
                                  rows="2"
                                  row-height="20"
                                  :error-messages="errors"
                                >
                                </v-textarea>
                              </validation-provider>

                              <validation-provider
                                v-slot="{ errors }"
                                name="Notes"
                                rules="required"
                              >
                                <v-textarea
                                  v-show="!active"
                                  label="Add Notes"
                                  v-model="serv.newNotes"
                                  outlined
                                  auto-grow
                                  hide-details
                                  rows="2"
                                  row-height="20"
                                  :error-messages="errors"
                                >
                                </v-textarea>
                              </validation-provider>
                            </v-col>
                          </v-row>

                          <v-row class="ma-3">
                            <v-col cols="12" sm="12" class="pa-1">
                              <v-text-field
                                v-show="!active"
                                label="Provider"
                                v-model="serv.Provider"
                                outlined
                                hide-details
                                multiple
                                readonly
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>

                          <v-row class="ma-3" v-if="serv.ServiceItem === 'Blood Pressure Monitoring'">
                            <v-col cols="12" sm="12" class="pa-1">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Blood Pressure"
                                rules="required"
                              >
                                <v-text-field
                                  v-show="!active"
                                  label="Blood Pressure"
                                  v-model="serv.BloodPressure"
                                  outlined
                                  multiple
                                  :error-messages="errors"
                                >
                                </v-text-field>
                              </validation-provider>
                            </v-col>
                          </v-row>

                          <v-row class="ma-3" align="center">
                            <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              :md="isBodyCheck(serv) ? 6: 12"
                              lg="6"
                              v-if="isBodyCheck(serv)"
                            >
                              <v-select
                                v-model="selectedInjuryItem"
                                :items="injuryItems"
                                label="Is there an injury?"
                                dense
                                outlined
                              ></v-select>
                            </v-col>

                            <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              :md="isBodyCheck(serv) ? 6: 12"
                              lg="6"
                              v-if="isBodyCheck(serv)"
                            >
                              <v-select
                                v-model="selectedSkinRequiredItem"
                                :items="isRequiredSkinCheck"
                                label="Add Body Check?"
                                outlined
                                dense
                                clearable
                                @change="selectCheckItem"
                              ></v-select>
                            </v-col>

                            <!--     
                    <v-select
                        style="margin-top: 20px"
                        v-show="serv.ServiceItem === 'Skin Check' || serv.ServiceItem === 'General Appearance'"
                        v-model="selectedInjuryItem"
                        :items="injuryItems"
                        label="Is there an injury?"
                        dense
                        outlined
                    ></v-select>
                    <v-select
                        style="margin-top: 10px"
                        v-show="serv.ServiceItem === 'Skin Check' || serv.ServiceItem === 'General Appearance'"
                        v-model="selectedSkinRequiredItem"
                        :items="isRequiredSkinCheck"
                        label="Skin Check"
                        dense
                        outlined
                    ></v-select>  
            -->
                          </v-row>

                          <v-row class="ma-3">
                            <v-col cols="12" md="12" class="mt-n8">
                              <v-checkbox
                                v-show="active"
                                label="Signature"
                                hide-details
                                @change="addSignature(serv, active)"
                                v-model="signed"
                              ></v-checkbox>
                              <v-checkbox
                                v-show="!active"
                                label="Signature"
                                hide-details
                                @change="addSignature(serv, active)"
                                v-model="serv.signed"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="12" class="mt-n8">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Signature"
                                rules="required"
                              >
                                <v-text-field
                                  v-show="active"
                                  v-model="newSignature"
                                  :error-messages="errors"
                                  readonly
                                ></v-text-field>
                              </validation-provider>

                              <validation-provider
                                v-slot="{ errors }"
                                name="Signature"
                                rules="required"
                              >
                                <v-text-field
                                  v-show="!active"
                                  v-model="serv.newSignature"
                                  :error-messages="errors"
                                  readonly
                                ></v-text-field>
                              </validation-provider>
                            </v-col>
                          </v-row>
                          <v-row class="ma-3">
                            <v-col>
                                <v-list dense v-if="serv.ServiceCodes.length > 0">
                                  <v-subheader>Service Codes</v-subheader>
                                  <v-chip v-for="(ServiceCode, id) in serv.ServiceCodes" :key="id">
                                    {{ ServiceCode.ServiceCode }}
                                  </v-chip>
                                </v-list>
                            </v-col>
                          </v-row>
                        </validation-observer>


                          <v-card-actions v-if="!isAuditorRole">
                            <!-- <v-btn
                      class="bg-color mb-3 mt-n4"
                      dark
                      block
                      color="primary"
                      :disabled="multipleSelectedItem"
                      @click="addADL(serv)"
                  >
                    submit
                  </v-btn> -->
                            <v-btn
                              class="mb-3 mt-n4"
                              block
                              color="primary"
                              :loading="$store.state.services.isLoading"
                              :disabled="
                                multipleSelectedItem
                                  ? multipleSelectedItem
                                  : isDisable
                              "
                              @click="addADL(serv, index)"
                            >
                              submit
                              <template v-slot:loader>
                                <span>Loading...</span>
                              </template>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-container>
              </v-item-group>
            </v-expansion-panel-content>
        </v-expansion-panel>
       
        <!-- AFTERNOON  -->
        
        <v-expansion-panel hide-actions v-show="afternoonServices.length > 0">
              <v-expansion-panel-header class="panel-header" @click="handleChangePanel('afternoon')">
                <template v-slot:actions>
                  <v-progress-circular
                    :value="service.afternoon.progress"
                    :color="service.afternoon.incomplete ? 'red' : 'success'"
                  >
                    <v-icon
                      :color="service.afternoon.incomplete ? 'red' : 'success'"
                      small
                    >
                      {{
                        service.afternoon.progress === 100
                          ? "mdi-check"
                          : "mdi-medical-bag"
                      }}
                    </v-icon>
                  </v-progress-circular>
                </template>
    
                <v-row align="center" justify="center" no-gutters>
                  <v-col cols="12" sm="12" md="4" class="my-1">
                    <v-row>
                      <v-col cols="4" sm="4" md="2" class="hidden-sm-and-down">
                        <v-avatar size="36px">
                          <v-icon color="teal">mdi-medical-bag</v-icon>
                        </v-avatar>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="10" class="my-1">
                        <div class="pa-2 d-flex justify-center">
                          <strong>{{ schedule.afternoon }} ADL's</strong>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
    
                  <v-col cols="12" sm="12" md="8">
                    <v-row wrap>
                      <v-col cols="12" sm="12" md="12">
                        <div class="d-flex justify-center pa-1">
                          <v-row class="justify-center justify-md-start">
                            <v-chip
                              :color="
                                service.afternoon.incomplete
                                  ? 'red lighten-4'
                                  : 'success lighten-4'
                              "
                              class="ml-0 mx-1 black--text my-1"
                              label
                              small
                            >
                              {{
                                service.afternoon.incomplete
                                  ? "INCOMPLETE"
                                  : "COMPLETE"
                              }}
                            </v-chip>
    
                            <v-chip
                              color="teal lighten-4"
                              class="ml-0 black--text my-1"
                              label
                              small
                            >
                              <span class="text-overline"
                                >{{ service.afternoon.completed }} /
                                {{ service.afternoon.total }} ADL’s completed</span
                              >
                            </v-chip>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-item-group multiple>
                  <v-container fluid class="pa-0">
                    <v-row>
                      <!-- LIST OF ADL -->
                      <v-col
                        cols="12"
                        md="4"
                        v-for="(serv, index) in afternoonServices.filter(
                          (item) => item.isSigned != true
                        )"
                        :key="index"
                        :class="defaultMargin"
                      >
                      <v-item v-slot="{ active, toggle }">
                          <v-card
                            min-height="100%"
                            id="ADLCard"
                            :color="active ? 'blue lighten-5' : ''"
                          >
                            <v-toolbar dark color="primary" dense>
                              <v-toolbar-title>
                                <v-card-title class="body-2">
                                  {{ serv.ServiceItem }} - {{ serv.Type }}
                                </v-card-title>
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-toolbar-items>
                                <div class="mr-n3" style="margin-top: 10px">
                                  <v-checkbox
                                    @click="
                                      toggle();
                                      selectedItem({ ...serv, active: !active });
                                    "
                                  ></v-checkbox>
                                </div>
                              </v-toolbar-items>
                            </v-toolbar>
    
                            <v-container
                              class="fill-height ma-0 pa-0 img-container"
                              fluid
                            >
                              <div class="overlay-fade ma-0 pa-0">
                                <v-chip
                                  class="ma-2 schedule-time darken-4"
                                  color="blue"
                                  label
                                  text-color="white"
                                >
                                  <v-icon left> mdi-clock </v-icon>
                                  {{ serv.newScheduledTime }}
                                </v-chip>
                                <v-chip
                                  v-if="!isAuditorRole"
                                  @click="openSkinCheckImageUploadDialog(serv)"
                                  v-show="isBodyCheck(serv)"
                                  class="btn-image-upload darken-4"
                                  color="blue"
                                  label
                                  text-color="white"
                                >
                                  <v-icon left>mdi-cloud-upload</v-icon>
                                  Upload
                                </v-chip>
                                <v-chip
                                  v-if="!isAuditorRole"
                                  @click="openServicePlanAttachmentsDialog(serv)"
                                  v-show="isBodyCheck(serv)"
                                  class="btn-view-image darken-4"
                                  color="blue"
                                  label
                                  text-color="white"
                                >
                                  <v-icon left>grid_view</v-icon>
                                  View All Images
                                </v-chip>
                                <v-chip
                                  v-if="!isAuditorRole"
                                  v-show="isBodyCheck(serv) && selectedInjuryItem === 'Yes'"
                                  class="btn-follow-up darken-4"
                                  color="blue"
                                  text-color="white"
                                >
                                  <v-select
                                    :items="followUpItems"
                                    @change="selectFollowUpItem"
                                    placeholder="You want to Follow Up?"
                                    dense
                                    outlined
                                  ></v-select>
                                </v-chip>
                                <v-chip
                                  v-if="!isAuditorRole"
                                  v-show="isBodyCheck(serv) && selectedInjuryItem === 'Yes'"
                                  @click="openCreateIncidentReportDialog(serv)"
                                  class="btn-incident-report darken-4"
                                  color="blue"
                                  text-color="white"
                                >
                                  <v-icon left>mdi-pencil</v-icon>
                                  Create Incident Report
                                </v-chip>
                                <span class="shared-link">
                                  <v-icon
                                    @click="createShareLink(serv)"
                                    class="mr-3 my-n5"
                                    color="white"
                                  >
                                    mdi-share-variant
                                  </v-icon>
                                </span>
                                <img
                                  v-if="!isBodyCheck(serv)"
                                  :src="serv.ImageUrl"
                                  class="adl-image"
                                />
                                <img
                                  v-else
                                  :src="serv.Attachments[0]"
                                  class="adl-image"
                                />
                                <div></div>
                              </div>
    
                              <p class="description ma-2 pa-2 text-body2">
                                <span v-if="serv.reveal">{{
                                  serv.Description.substring(0, 150)
                                }}</span>
                                <span
                                  v-if="serv.Description.length >= 150"
                                  @click="readMore(index, serv)"
                                >
                                  <a
                                    color="#BBDEFB"
                                    class="caption"
                                    v-if="serv.reveal"
                                    >...Read More
                                  </a>
                                </span>
    
                                <v-divider></v-divider>
    
                                <v-expand-transition>
                                  <v-card
                                    v-if="reveal && cardIndex === index"
                                    class="transition-fast-in-fast-out v-card--reveal"
                                    style="height: 500"
                                  >
                                    <v-card-text class="pb-0">
                                      <p>{{ serv.Description }}</p>
                                    </v-card-text>
                                    <v-card-actions>
                                      <v-list-item class="grow">
                                        <v-row justify="end">
                                          <v-btn
                                            text
                                            color="primary accent-4"
                                            @click="onReveal(serv)"
                                          >
                                            Close
                                          </v-btn>
                                        </v-row>
                                      </v-list-item>
                                    </v-card-actions>
                                  </v-card>
                                </v-expand-transition>
                              </p>
                            </v-container>
                            <validation-observer ref="afternoonObserver">
                              <v-row dense class="ma-3">
                                <v-col cols="12" sm="6">
                                  <v-select
                                    v-show="
                                      active && !isBodyCheck(serv)
                                    "
                                    label="Assistance"
                                    outlined
                                    v-model="newAssistance"
                                    :items="assistance"
                                    hide-details
                                  >
                                  </v-select>
                                  <v-select
                                    v-show="
                                      !active && !isBodyCheck(serv)
                                    "
                                    label="Assistance"
                                    outlined
                                    v-model="serv.LOA"
                                    :items="assistance"
                                    hide-details
                                  >
                                  </v-select>
                                </v-col>
                                <v-col cols="12" sm="6">
                                  <v-select
                                    v-show="active"
                                    label="Exception"
                                    v-model="newException"
                                    outlined
                                    height="10"
                                    :items="exception"
                                    clearable
                                    hide-details
                                  ></v-select>
                                  <v-select
                                    v-show="!active"
                                    label="Exception"
                                    v-model="serv.newException"
                                    outlined
                                    height="10"
                                    :items="exception"
                                    clearable
                                    hide-details
                                  ></v-select>
                                </v-col>
                              </v-row>
      
                              <v-row class="ma-3">
                                <v-col cols="12" sm="12" class="pa-1">

                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Notes"
                                    rules="required"
                                  >
                                    <v-textarea
                                      v-show="active"
                                      label="Add Notes"
                                      v-model="newNotes"
                                      outlined
                                      auto-grow
                                      hide-details
                                      rows="2"
                                      row-height="20"
                                      :error-messages="errors"
                                    >
                                    </v-textarea>
                                  </validation-provider>

                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Notes"
                                    rules="required"
                                  >
                                    <v-textarea
                                      v-show="!active"
                                      label="Add Notes"
                                      v-model="serv.newNotes"
                                      outlined
                                      auto-grow
                                      hide-details
                                      rows="2"
                                      row-height="20"
                                      :error-messages="errors"
                                    >
                                    </v-textarea>
                                  </validation-provider>

                                  <!-- <v-textarea
                                    v-show="!active"
                                    label="Add Notes"
                                    v-model="serv.newNotes"
                                    outlined
                                    auto-grow
                                    hide-details
                                    rows="2"
                                    row-height="20"
                                  >
                                  </v-textarea> -->
                                </v-col>
                              </v-row>
      
                              <v-row class="ma-3">
                                <v-col cols="12" sm="12" class="pa-1">
                                  <v-text-field
                                    v-show="!active"
                                    label="Provider"
                                    v-model="serv.Provider"
                                    outlined
                                    hide-details
                                    multiple
                                    readonly
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
      
                              <v-row class="ma-3" v-if="serv.ServiceItem === 'Blood Pressure Monitoring'">
                                <v-col cols="12" sm="12" class="pa-1">
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Blood Pressure"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-show="!active"
                                      label="Blood Pressure"
                                      v-model="serv.BloodPressure"
                                      outlined
                                      multiple
                                      :error-messages="errors"
                                    >
                                    </v-text-field>
                                  </validation-provider>
                                </v-col>
                              </v-row>
      
                              <v-row class="ma-3" align="center">
                                <v-col
                                  class="d-flex"
                                  cols="12"
                                  sm="12"
                                  :md=" isBodyCheck(serv) ? 6 : 12"
                                  lg="6"
                                  v-if="isBodyCheck(serv)"
                                >
                                  <v-select
                                    v-model="selectedInjuryItem"
                                    :items="injuryItems"
                                    label="Is there an injury?"
                                    dense
                                    outlined
                                  ></v-select>
                                </v-col>
      
                                <v-col
                                  class="d-flex"
                                  cols="12"
                                  sm="12"
                                  :md=" isBodyCheck(serv) ? 6 : 12"
                                  lg="6"
                                  v-if="isBodyCheck(serv)"
                                >
                                  <v-select
                                    v-model="selectedSkinRequiredItem"
                                    :items="isRequiredSkinCheck"
                                    label="Add Body Check?"
                                    outlined
                                    dense
                                    clearable
                                    @change="selectCheckItem"
                                  ></v-select>
                                </v-col>
      
                                <!--     
                        <v-select
                            style="margin-top: 20px"
                            v-show="serv.ServiceItem === 'Skin Check' || serv.ServiceItem === 'General Appearance'"
                            v-model="selectedInjuryItem"
                            :items="injuryItems"
                            label="Is there an injury?"
                            dense
                            outlined
                        ></v-select>
                        <v-select
                            style="margin-top: 10px"
                            v-show="serv.ServiceItem === 'Skin Check' || serv.ServiceItem === 'General Appearance'"
                            v-model="selectedSkinRequiredItem"
                            :items="isRequiredSkinCheck"
                            label="Skin Check"
                            dense
                            outlined
                        ></v-select>  
                -->
                              </v-row>
      
                              <v-row class="ma-3">
                                <v-col cols="12" md="12" class="mt-n8">
                                  <v-checkbox
                                    v-show="active"
                                    label="Signature"
                                    hide-details
                                    @change="addSignature(serv, active)"
                                    v-model="signed"
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-show="!active"
                                    label="Signature"
                                    hide-details
                                    @change="addSignature(serv, active)"
                                    v-model="serv.signed"
                                  ></v-checkbox>
                                </v-col>
                                <v-col cols="12" md="12" class="mt-n8">
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Signature"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-show="active"
                                      v-model="newSignature"
                                      :error-messages="errors"
                                      readonly
                                    ></v-text-field>
                                  </validation-provider>
      
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Signature"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-show="!active"
                                      v-model="serv.newSignature"
                                      :error-messages="errors"
                                      readonly
                                    ></v-text-field>
                                  </validation-provider>
                                </v-col>
                              </v-row>
                              <v-row class="ma-3">
                                <v-col>
                                    <v-list dense v-if="serv.ServiceCodes.length > 0">
                                      <v-subheader>Service Codes</v-subheader>
                                      <v-chip v-for="(ServiceCode, id) in serv.ServiceCodes" :key="id">
                                        {{ ServiceCode.ServiceCode }}
                                      </v-chip>
                                    </v-list>
                                </v-col>
                              </v-row>
                            </validation-observer>
    
                            <v-card-actions v-if="!isAuditorRole">
                              <!-- <v-btn
                        class="bg-color mb-3 mt-n4"
                        dark
                        block
                        color="primary"
                        :disabled="multipleSelectedItem"
                        @click="addADL(serv)"
                    >
                      submit
                    </v-btn> -->
                              <v-btn
                                class="mb-3 mt-n4"
                                block
                                color="primary"
                                :loading="$store.state.services.isLoading"
                                :disabled="
                                  multipleSelectedItem
                                    ? multipleSelectedItem
                                    : isDisable
                                "
                                @click="addADL(serv, index)"
                              >
                                submit
                                <template v-slot:loader>
                                  <span>Loading...</span>
                                </template>
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-item>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-item-group>
              </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- EVENING  -->
        <v-expansion-panel v-show="eveningServices.length > 0">
            <v-expansion-panel-header class="panel-header" @click="handleChangePanel('evening')">
              <template v-slot:actions>
                <v-progress-circular
                  :value="service.evening.progress"
                  :color="service.evening.incomplete ? 'red' : 'success'"
                >
                  <v-icon
                    :color="service.evening.incomplete ? 'red' : 'success'"
                    small
                  >
                    {{
                      service.evening.progress === 100
                        ? "mdi-check"
                        : "mdi-medical-bag"
                    }}
                  </v-icon>
                </v-progress-circular>
              </template>

              <v-row align="center" justify="center" no-gutters>
                <v-col cols="12" sm="12" md="4" class="my-1">
                  <v-row>
                    <v-col cols="4" sm="4" md="2" class="hidden-sm-and-down">
                      <v-avatar size="36px">
                        <v-icon color="teal">mdi-medical-bag</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="10" class="my-1">
                      <div class="pa-2 d-flex justify-center">
                        <strong>{{ schedule.evening }} ADL's</strong>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" sm="12" md="8">
                  <v-row wrap>
                    <v-col cols="12" sm="12" md="12">
                      <div class="d-flex justify-center pa-1">
                        <v-row class="justify-center justify-md-start">
                          <v-chip
                            :color="
                              service.evening.incomplete
                                ? 'red lighten-4'
                                : 'success lighten-4'
                            "
                            class="ml-0 mx-1 black--text my-1"
                            label
                            small
                          >
                            {{
                              service.evening.incomplete
                                ? "INCOMPLETE"
                                : "COMPLETE"
                            }}
                          </v-chip>

                          <v-chip
                            color="teal lighten-4"
                            class="ml-0 black--text my-1"
                            label
                            small
                          >
                            <span class="text-overline"
                              >{{ service.evening.completed }} /
                              {{ service.evening.total }} ADL’s completed</span
                            >
                          </v-chip>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-item-group multiple>
                <v-container fluid class="pa-0">
                  <v-row>
                    <!-- LIST OF ADL -->
                    <v-col
                      cols="12"
                      md="4"
                      v-for="(serv, index) in eveningServices.filter(
                        (item) => item.isSigned != true
                      )"
                      :key="index"
                      :class="defaultMargin"
                    >
                    <v-item v-slot="{ active, toggle }">
                        <v-card
                          min-height="100%"
                          id="ADLCard"
                          :color="active ? 'blue lighten-5' : ''"
                        >
                          <v-toolbar dark color="primary" dense>
                            <v-toolbar-title>
                              <v-card-title class="body-2">
                                {{ serv.ServiceItem }} - {{ serv.Type }}
                              </v-card-title>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                              <div class="mr-n3" style="margin-top: 10px">
                                <v-checkbox
                                  @click="
                                    toggle();
                                    selectedItem({ ...serv, active: !active });
                                  "
                                ></v-checkbox>
                              </div>
                            </v-toolbar-items>
                          </v-toolbar>

                          <v-container
                            class="fill-height ma-0 pa-0 img-container"
                            fluid
                          >
                            <div class="overlay-fade ma-0 pa-0">
                              <v-chip
                                class="ma-2 schedule-time darken-4"
                                color="blue"
                                label
                                text-color="white"
                              >
                                <v-icon left> mdi-clock </v-icon>
                                {{ serv.newScheduledTime }}
                              </v-chip>
                              <v-chip
                                v-if="!isAuditorRole"
                                @click="openSkinCheckImageUploadDialog(serv)"
                                v-show="isBodyCheck(serv)"
                                class="btn-image-upload darken-4"
                                color="blue"
                                label
                                text-color="white"
                              >
                                <v-icon left>mdi-cloud-upload</v-icon>
                                Upload
                              </v-chip>
                              <v-chip
                                v-if="!isAuditorRole"
                                @click="openServicePlanAttachmentsDialog(serv)"
                                v-show="isBodyCheck(serv)"
                                class="btn-view-image darken-4"
                                color="blue"
                                label
                                text-color="white"
                              >
                                <v-icon left>grid_view</v-icon>
                                View All Images
                              </v-chip>
                              <v-chip
                                v-show="
                                isBodyCheck(serv) && selectedInjuryItem === 'Yes'"
                                class="btn-follow-up darken-4"
                                color="blue"
                                text-color="white"
                              >
                                <v-select
                                  :items="followUpItems"
                                  @change="selectFollowUpItem"
                                  placeholder="You want to Follow Up?"
                                  dense
                                  outlined
                                ></v-select>
                              </v-chip>
                              <v-chip
                                v-if="!isAuditorRole"
                                v-show="isBodyCheck(serv) || selectedInjuryItem === 'Yes'"
                                @click="openCreateIncidentReportDialog(serv)"
                                class="btn-incident-report darken-4"
                                color="blue"
                                text-color="white"
                              >
                                <v-icon left>mdi-pencil</v-icon>
                                Create Incident Report
                              </v-chip>
                              <span class="shared-link">
                                <v-icon
                                  @click="createShareLink(serv)"
                                  class="mr-3 my-n5"
                                  color="white"
                                >
                                  mdi-share-variant
                                </v-icon>
                              </span>
                              <img
                                v-if="!isBodyCheck(serv)"
                                :src="serv.ImageUrl"
                                class="adl-image"
                              />
                              <img
                                v-else
                                :src="serv.Attachments[0]"
                                class="adl-image"
                              />
                              <div></div>
                            </div>

                            <p class="description ma-2 pa-2 text-body2">
                              <span v-if="serv.reveal">{{
                                serv.Description.substring(0, 150)
                              }}</span>
                              <span
                                v-if="serv.Description.length >= 150"
                                @click="readMore(index, serv)"
                              >
                                <a
                                  color="#BBDEFB"
                                  class="caption"
                                  v-if="serv.reveal"
                                  >...Read More
                                </a>
                              </span>

                              <v-divider></v-divider>

                              <v-expand-transition>
                                <v-card
                                  v-if="reveal && cardIndex === index"
                                  class="transition-fast-in-fast-out v-card--reveal"
                                  style="height: 500"
                                >
                                  <v-card-text class="pb-0">
                                    <p>{{ serv.Description }}</p>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-list-item class="grow">
                                      <v-row justify="end">
                                        <v-btn
                                          text
                                          color="primary accent-4"
                                          @click="onReveal(serv)"
                                        >
                                          Close
                                        </v-btn>
                                      </v-row>
                                    </v-list-item>
                                  </v-card-actions>
                                </v-card>
                              </v-expand-transition>
                            </p>
                          </v-container>

                        <validation-observer ref="eveningObserver">
                          <v-row dense class="ma-3">
                            <v-col cols="12" sm="6">
                              <v-select
                                v-show="
                                  active && !isBodyCheck(serv)
                                "
                                label="Assistance"
                                outlined
                                v-model="newAssistance"
                                :items="assistance"
                                hide-details
                              >
                              </v-select>
                              <v-select
                                v-show="
                                  !active && !isBodyCheck(serv)
                                "
                                label="Assistance"
                                outlined
                                v-model="serv.LOA"
                                :items="assistance"
                                hide-details
                              >
                              </v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-select
                                v-show="active"
                                label="Exception"
                                v-model="newException"
                                outlined
                                height="10"
                                :items="exception"
                                clearable
                                hide-details
                              ></v-select>
                              <v-select
                                v-show="!active"
                                label="Exception"
                                v-model="serv.newException"
                                outlined
                                height="10"
                                :items="exception"
                                clearable
                                hide-details
                              ></v-select>
                            </v-col>
                          </v-row>

                          <v-row class="ma-3">
                            <v-col cols="12" sm="12" class="pa-1">
                              <validation-provider
                                    v-slot="{ errors }"
                                    name="Notes"
                                    rules="required"
                                  >
                                    <v-textarea
                                      v-show="active"
                                      label="Add Notes"
                                      v-model="newNotes"
                                      outlined
                                      auto-grow
                                      hide-details
                                      rows="2"
                                      row-height="20"
                                      :error-messages="errors"
                                    >
                                    </v-textarea>
                                  </validation-provider>

                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Notes"
                                    rules="required"
                                  >
                                    <v-textarea
                                      v-show="!active"
                                      label="Add Notes"
                                      v-model="serv.newNotes"
                                      outlined
                                      auto-grow
                                      hide-details
                                      rows="2"
                                      row-height="20"
                                      :error-messages="errors"
                                    >
                                    </v-textarea>
                                  </validation-provider>
                            </v-col>
                          </v-row>

                          <v-row class="ma-3">
                            <v-col cols="12" sm="12" class="pa-1">
                              <v-text-field
                                v-show="!active"
                                label="Provider"
                                v-model="serv.Provider"
                                outlined
                                hide-details
                                multiple
                                readonly
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>

                          <v-row class="ma-3" v-if="serv.ServiceItem === 'Blood Pressure Monitoring'">
                            <v-col cols="12" sm="12" class="pa-1">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Blood Pressure"
                                rules="required"
                              >
                                <v-text-field
                                  v-show="!active"
                                  label="Blood Pressure"
                                  v-model="serv.BloodPressure"
                                  outlined
                                  multiple
                                  :error-messages="errors"
                                >
                                </v-text-field>
                              </validation-provider>
                            </v-col>
                          </v-row>

                          <v-row class="ma-3" align="center">
                            <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              :md="isBodyCheck(serv) ? 6 : 12"
                              lg="6"
                              v-if="isBodyCheck(serv)"
                            >
                              <v-select
                                v-model="selectedInjuryItem"
                                :items="injuryItems"
                                label="Is there an injury?"
                                dense
                                outlined
                              ></v-select>
                            </v-col>

                            <v-col
                              class="d-flex"
                              cols="12"
                              sm="12"
                              :md="isBodyCheck(serv) ? 6 : 12"
                              lg="6"
                              v-if="isBodyCheck(serv)"
                            >
                              <v-select
                                v-model="selectedSkinRequiredItem"
                                :items="isRequiredSkinCheck"
                                label="Add Body Check?"
                                outlined
                                dense
                                clearable
                                @change="selectCheckItem"
                              ></v-select>
                            </v-col>

                            <!--     
                    <v-select
                        style="margin-top: 20px"
                        v-show="serv.ServiceItem === 'Skin Check' || serv.ServiceItem === 'General Appearance'"
                        v-model="selectedInjuryItem"
                        :items="injuryItems"
                        label="Is there an injury?"
                        dense
                        outlined
                    ></v-select>
                    <v-select
                        style="margin-top: 10px"
                        v-show="serv.ServiceItem === 'Skin Check' || serv.ServiceItem === 'General Appearance'"
                        v-model="selectedSkinRequiredItem"
                        :items="isRequiredSkinCheck"
                        label="Skin Check"
                        dense
                        outlined
                    ></v-select>  
            -->
                          </v-row>

                          <v-row class="ma-3">
                            <v-col cols="12" md="12" class="mt-n8">
                              <v-checkbox
                                v-show="active"
                                label="Signature"
                                hide-details
                                @change="addSignature(serv, active)"
                                v-model="signed"
                              ></v-checkbox>
                              <v-checkbox
                                v-show="!active"
                                label="Signature"
                                hide-details
                                @change="addSignature(serv, active)"
                                v-model="serv.signed"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="12" class="mt-n8">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Signature"
                                rules="required"
                              >
                                <v-text-field
                                  v-show="active"
                                  v-model="newSignature"
                                  :error-messages="errors"
                                  readonly
                                ></v-text-field>
                              </validation-provider>

                              <validation-provider
                                v-slot="{ errors }"
                                name="Signature"
                                rules="required"
                              >
                                <v-text-field
                                  v-show="!active"
                                  v-model="serv.newSignature"
                                  :error-messages="errors"
                                  readonly
                                ></v-text-field>
                              </validation-provider>
                            </v-col>
                          </v-row>
                              <v-row class="ma-3">
                                <v-col>
                                    <v-list dense v-if="serv.ServiceCodes.length > 0">
                                      <v-subheader>Service Codes</v-subheader>
                                      <v-chip v-for="(ServiceCode, id) in serv.ServiceCodes" :key="id">
                                        {{ ServiceCode.ServiceCode }}
                                      </v-chip>
                                    </v-list>
                                </v-col>
                              </v-row>
                        </validation-observer>

                          <v-card-actions v-if="!isAuditorRole">
                            <!-- <v-btn
                      class="bg-color mb-3 mt-n4"
                      dark
                      block
                      color="primary"
                      :disabled="multipleSelectedItem"
                      @click="addADL(serv)"
                  >
                    submit
                  </v-btn> -->
                            <v-btn
                              class="mb-3 mt-n4"
                              block
                              color="primary"
                              :loading="$store.state.services.isLoading"
                              :disabled="
                                multipleSelectedItem
                                  ? multipleSelectedItem
                                  : isDisable
                              "
                              @click="addADL(serv, index)"
                            >
                              submit
                              <template v-slot:loader>
                                <span>Loading...</span>
                              </template>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-container>
              </v-item-group>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- PRN  -->
        <v-expansion-panel hide-actions v-show="prnServices.length > 0">
            <v-expansion-panel-header class="panel-header" @click="handleChangePanel('prn')">
              <template v-slot:actions>
                <v-progress-circular
                  :value="service.daily.progress"
                  :color="service.daily.incomplete ? 'red' : 'success'"
                >
                  <v-icon
                    :color="service.daily.incomplete ? 'red' : 'success'"
                    small
                  >
                    {{
                      service.daily.progress === 100
                        ? "mdi-check"
                        : "mdi-medical-bag"
                    }}
                  </v-icon>
                </v-progress-circular>
              </template>

              <v-row align="center" justify="center" no-gutters>
                <v-col cols="12" sm="12" md="4" class="my-1">
                  <v-row>
                    <v-col cols="4" sm="4" md="2" class="hidden-sm-and-down">
                      <v-avatar size="36px">
                        <v-icon color="teal">mdi-medical-bag</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="10" class="my-1">
                      <div class="pa-2 d-flex justify-center">
                        <strong>{{ schedule.daily }} ADL's</strong>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" sm="12" md="8">
                  <v-row wrap>
                    <v-col cols="12" sm="12" md="12">
                      <div class="d-flex justify-center pa-1">
                        <v-row class="justify-center justify-md-start">
                          <v-chip
                            :color="
                              service.daily.incomplete
                                ? 'red lighten-4'
                                : 'success lighten-4'
                            "
                            class="ml-0 mx-1 black--text my-1"
                            label
                            small
                          >
                            {{
                              service.daily.incomplete ? "INCOMPLETE" : "COMPLETE"
                            }}
                          </v-chip>

                          <v-chip
                            color="teal lighten-4"
                            class="ml-0 black--text my-1"
                            label
                            small
                          >
                            <span class="text-overline"
                              >{{ service.daily.completed }} /
                              {{ service.daily.total }} ADL’s completed</span
                            >
                          </v-chip>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-item-group multiple>
                <v-container fluid class="pa-0">
                  <v-row>
                    <!-- LIST OF ADL -->
                    <v-col
                      cols="12"
                      md="4"
                      v-for="(serv, index) in prnServices.filter(
                        (item) => item.isSigned != true
                      )"
                      :key="index"
                      :class="defaultMargin"
                    >
                      <v-item v-slot="{ active, toggle }">
                        <v-card
                          x-width="100%"
                          min-height="100%"
                          id="ADLCard"
                          :color="active ? 'blue lighten-5' : ''"
                        >
                          <v-toolbar dark color="primary" dense>
                            <v-toolbar-title>
                              <v-card-title class="body-2">
                                {{ serv.ServiceItem }} - {{ serv.Type }}
                              </v-card-title>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                              <div class="mr-n3" style="margin-top: 10px">
                                <v-checkbox
                                  @click="
                                    toggle();
                                    selectedItem({ ...serv, active: !active });
                                  "
                                ></v-checkbox>
                              </div>
                            </v-toolbar-items>
                          </v-toolbar>

                          <v-container
                            class="fill-height ma-0 pa-0 img-container"
                            fluid
                          >
                            <div class="overlay-fade ma-0 pa-0">
                              <v-chip
                                class="ma-2 schedule-time darken-4"
                                color="blue"
                                label
                                text-color="white"
                              >
                                <v-icon left> mdi-clock </v-icon>
                                {{ serv.newScheduledTime }}
                              </v-chip>
                              <v-chip
                                v-if="!isAuditorRole"
                                @click="openSkinCheckImageUploadDialog(serv)"
                                v-show="isBodyCheck(serv)"
                                class="btn-image-upload darken-4"
                                color="blue"
                                label
                                text-color="white"
                              >
                                <v-icon left>mdi-cloud-upload</v-icon>
                                Upload
                              </v-chip>
                              <v-chip
                                v-if="!isAuditorRole"
                                @click="openServicePlanAttachmentsDialog(serv)"
                                v-show="isBodyCheck(serv)"
                                class="btn-view-image darken-4"
                                color="blue"
                                label
                                text-color="white"
                              >
                                <v-icon left>grid_view</v-icon>
                                View All Images
                              </v-chip>
                              <v-chip
                                v-if="!isAuditorRole"
                                v-show="
                                 isBodyCheck(serv) &&
                                  selectedInjuryItem === 'Yes'
                                "
                                class="btn-follow-up darken-4"
                                color="blue"
                                label
                                text-color="white"
                              >
                                <v-select
                                  :items="followUpItems"
                                  @change="selectFollowUpItem"
                                  placeholder="You want to Follow Up?"
                                  outlined
                                ></v-select>
                              </v-chip>
                              <span class="shared-link">
                                <v-icon
                                  class="mr-3 my-n5"
                                  color="white"
                                  @click="createShareLink(serv)"
                                >
                                  mdi-share-variant
                                </v-icon>
                              </span>
                              <img
                                v-if="!isBodyCheck(serv)"
                                :src="serv.ImageUrl"
                                class="adl-image"
                              />
                              <img
                                v-else
                                :src="serv.Attachments[0]"
                                class="adl-image"
                              />
                              <div></div>
                            </div>

                            <p class="description ma-2 pa-2 text-body2">
                              <span v-if="serv.reveal">{{
                                serv.Description.substring(0, 150)
                              }}</span>
                              <span
                                v-if="serv.Description.length >= 150"
                                @click="readMore(index, serv)"
                              >
                                <a
                                  color="#BBDEFB"
                                  class="caption"
                                  v-if="serv.reveal"
                                  >...Read More
                                </a>
                              </span>

                              <v-expand-transition>
                                <v-card
                                  v-if="reveal && cardIndex === index"
                                  class="transition-fast-in-fast-out v-card--reveal"
                                  style="height: 500"
                                >
                                  <v-card-text class="pb-0">
                                    <p>{{ serv.Description }}</p>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-list-item class="grow">
                                      <v-row justify="end">
                                        <v-btn
                                          text
                                          color="primary accent-4"
                                          @click="onReveal(serv)"
                                        >
                                          Close
                                        </v-btn>
                                      </v-row>
                                    </v-list-item>
                                  </v-card-actions>
                                </v-card>
                              </v-expand-transition>
                            </p>
                          </v-container>
                          <validation-observer ref="prnObserver">
                          <v-row dense class="ma-3">
                            <v-col cols="12" sm="6">
                              <v-select
                                v-show="
                                  active && !isBodyCheck(serv)
                                "
                                label="Assistance"
                                outlined
                                v-model="newAssistance"
                                :items="assistance"
                                hide-details
                              >
                              </v-select>
                              <v-select
                                v-show="
                                  !active && !isBodyCheck(serv)
                                "
                                label="Assistance"
                                outlined
                                v-model="serv.LOA"
                                :items="assistance"
                                hide-details
                              >
                              </v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-select
                                v-show="active"
                                label="Exception"
                                v-model="newException"
                                outlined
                                height="10"
                                :items="exception"
                                clearable
                                hide-details
                              ></v-select>
                              <v-select
                                v-show="!active"
                                label="Exception"
                                v-model="serv.newException"
                                outlined
                                height="10"
                                :items="exception"
                                clearable
                                hide-details
                              ></v-select>
                            </v-col>
                          </v-row>

                          <v-row class="ma-3">
                            <v-col cols="12" sm="12" class="pa-1">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Notes"
                                rules="required"
                              >
                                <v-textarea
                                  v-show="active"
                                  label="Add Notes"
                                  v-model="newNotes"
                                  outlined
                                  auto-grow
                                  hide-details
                                  rows="2"
                                  row-height="20"
                                  :error-messages="errors"
                                >
                                </v-textarea>
                              </validation-provider>

                              <validation-provider
                                v-slot="{ errors }"
                                name="Notes"
                                rules="required"
                              >
                                <v-textarea
                                  v-show="!active"
                                  label="Add Notes"
                                  v-model="serv.newNotes"
                                  outlined
                                  auto-grow
                                  hide-details
                                  rows="2"
                                  row-height="20"
                                  :error-messages="errors"
                                >
                                </v-textarea>
                              </validation-provider>
                              <v-select
                                style="margin-top: 20px"
                                v-show="isBodyCheck(serv)"
                                v-model="selectedInjuryItem"
                                :items="injuryItems"
                                label="Is there an injury?"
                                dense
                                outlined
                              ></v-select>
                            </v-col>
                          </v-row>

                          <v-row class="ma-3">
                            <v-col cols="12" sm="12" class="pa-1">
                              <v-text-field
                                v-show="!active"
                                label="Provider"
                                v-model="serv.Provider"
                                outlined
                                hide-details
                                multiple
                                readonly
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>

                          <v-row class="ma-3" v-if="serv.ServiceItem === 'Blood Pressure Monitoring'">
                            <v-col cols="12" sm="12" class="pa-1">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Blood Pressure"
                                rules="required"
                              >
                                <v-text-field
                                  v-show="!active"
                                  label="Blood Pressure"
                                  v-model="serv.BloodPressure"
                                  outlined
                                  multiple
                                  :error-messages="errors"
                                >
                                </v-text-field>
                              </validation-provider>
                            </v-col>
                          </v-row>

                          <v-row class="ma-3">
                            <v-col cols="12" md="12" class="mt-n8">
                              <v-checkbox
                                v-show="active"
                                label="Signature"
                                hide-details
                                @change="addSignature(serv, active)"
                                v-model="signed"
                              ></v-checkbox>
                              <v-checkbox
                                v-show="!active"
                                label="Signature"
                                hide-details
                                @change="addSignature(serv, active)"
                                v-model="serv.signed"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="12" class="mt-n8">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Signature"
                                rules="required"
                              >
                                <v-text-field
                                  v-show="active"
                                  v-model="newSignature"
                                  :error-messages="errors"
                                  readonly
                                ></v-text-field>
                              </validation-provider>

                              <validation-provider
                                v-slot="{ errors }"
                                name="Signature"
                                rules="required"
                              >
                                <v-text-field
                                  v-show="!active"
                                  v-model="serv.newSignature"
                                  :error-messages="errors"
                                  readonly
                                ></v-text-field>
                              </validation-provider>
                            </v-col>
                          </v-row>
                        </validation-observer>

                          <v-card-actions  v-if="!isAuditorRole">
                            <!-- <v-btn
                  class="bg-color mb-3 mt-n4"
                  dark
                  block
                  color="primary"
                  :disabled="multipleSelectedItem"
                  @click="addADL(serv)"
              >
                submit
              </v-btn> -->
                            <v-btn
                              class="mb-3 mt-n4"
                              block
                              color="primary"
                              :loading="$store.state.services.isLoading"
                              :disabled="
                                multipleSelectedItem
                                  ? multipleSelectedItem
                                  : isDisable
                              "
                              @click="addADL(serv, index)"
                            >
                              submit
                              <template v-slot:loader>
                                <span>Loading...</span>
                              </template>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-container>
              </v-item-group>
            </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

    <v-dialog v-model="isFollowUpDialogOpen" max-width="600px">
      <v-card>
        <v-card-title>
          <h5>Create Follow Up Service Plan</h5>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form>
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <v-select
                    v-model="selectedServiceItem"
                    label="Service Item"
                    :items="followUpServiceItem"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-select
                    v-model="selectedFollowUpType"
                    label="Time to be completed"
                    :items="followUpType"
                    :rules="requiredRulesForFollowUp"
                  ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12" md="3">
                  <v-select
                    v-model="selectedFollowUpProvider"
                    label="Provider"
                    :items="followUpProvider"
                  ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12" md="3">
                  <v-select
                    v-model="selectedFollowUpLoa"
                    label="Level of Assistance"
                    :items="followUpLoa"
                  ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12" md="3">
                  <v-select
                    v-model="selectedFollowUpDays"
                    label="Days"
                    :items="followUpDays"
                    multiple
                  ></v-select>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12">
                  <v-textarea
                    v-model="followUpDescription"
                    label="Description"
                    outlined
                  ></v-textarea>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu
                    ref="followUpMenu"
                    v-model="followUpMenu"
                    :close-on-content-click="false"
                    :return-value.sync="followUpDate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="followUpStartDate"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="followUpStartDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="followUpMenu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.followUpMenu.save(followUpDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu
                    ref="followUpMenu2"
                    v-model="followUpMenu2"
                    :close-on-content-click="false"
                    :return-value.sync="followUpDate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="followUpEndDate"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="followUpEndDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="followUpMenu2 = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.followUpMenu2.save(followUpDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-select
                    label="Status"
                    :items="followUpStatus"
                    v-model="selectedFollowUpStatus"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="bg-color mb-3 mt-n4"
            dark
            color="red"
            @click="closeFollowUpDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            class="bg-color mb-3 mt-n4"
            dark
            color="primary"
            @click="createFollowUpServicePlan"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isOpenServicePlanAttachmentsDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <h5>Body Check Images</h5>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                v-for="attachment in selectedServicePlan.Attachments"
                :key="attachment._id"
                class="d-flex child-flex"
                cols="4"
              >
                <v-img
                  :src="attachment.AWSLink"
                  :lazy-src="attachment.AWSLink"
                  aspect-ratio="1"
                  class="grey lighten-2"
                >
                  <v-icon small class="ma-2" @click="downloadImage(attachment)">
                    file_download
                  </v-icon>
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isOpenCreateIncidentReportDialog" max-width="800px">
      <v-card>
        <v-card-title style="background-color: #2b3990">
          <span class="headline white--text">{{ titleForm }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <span>Is this related to a Human Rights Restriction?</span>
                  <v-row>
                    <v-col cols="12" sm="2">
                      <v-checkbox
                        label="Yes"
                        value="Yes"
                        v-model="humanRights"
                      ></v-checkbox>
                    </v-col>

                    <v-col cols="12" sm="2">
                      <v-checkbox
                        label="No"
                        value="No"
                        v-model="humanRights"
                      ></v-checkbox>
                    </v-col>

                    <v-col cols="12" sm="8" v-if="humanRights == 'Yes'">
                      <v-select
                        return-object
                        label="Select Human Rights"
                        :items="rights"
                        item-text="Restriction"
                        item-value="_id"
                        v-model="restriction"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-select
                    v-model="newType"
                    label="Incident Category"
                    :items="category"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <v-menu
                    ref="calendarMenu"
                    v-model="calendarMenu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newIncidentDateTime"
                        label="Incident Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requiredField"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newIncidentDateTime"
                      no-title
                      scrollable
                      :rules="requiredField"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="calendarMenu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.calendarMenu.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <v-menu
                    ref="calendar2Menu"
                    v-model="calendar2Menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newTodaysDate"
                        label="Incident Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="requiredField"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newTodaysDate"
                      no-title
                      scrollable
                      :rules="requiredField"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="calendar2Menu = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.calendar2Menu.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-menu offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-datetime-picker
                        v-model="newIncidentDiscovered"
                        label="Incident Discovered Date and Time"
                        prepend-icon="events"
                        v-on="on"
                      ></v-datetime-picker>
                    </template>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-select
                    label="Program"
                    v-model="newProgram"
                    :items="units"
                    item-text="Name"
                    item-value="Name"
                  ></v-select>
                </v-col>

                <v-col
                  cols="12"
                  class="white--text text-uppercase text-center"
                  style="background-color: #2b3990; border-radius: 10px"
                  >Incident Location</v-col
                >

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-model="newIncidentLocation"
                    label="Incident Location"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-model="newStreet"
                    label="Street"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field v-model="newCity" label="City"></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field v-model="newState" label="State"></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-model="newZipCode"
                    label="Zip Code"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-select
                    v-model="newIncidentLocationType"
                    label="Incident Location Type"
                    :items="location"
                  ></v-select>
                </v-col>

                <v-col
                  cols="12"
                  class="white--text text-uppercase text-center"
                  style="background-color: #2b3990; border-radius: 10px"
                  >People Involved</v-col
                >

                <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="newPersonInvolved1"
                    label="Name of Person Involved"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="newTitle1"
                    label="Title"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="newPhone1"
                    label="Phone Number"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" md="4">
                  <v-select
                    v-model="newRoles1"
                    label="Persons Role"
                    :items="roles"
                  ></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" md="4">
                  <v-select
                    v-model="newInvolvement1"
                    label="Persons Involvement Role"
                    :items="involvement"
                  ></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" md="4">
                  <v-btn @click="person2 = 'true'">Add Another Person</v-btn>
                </v-col>

                <!-- end of person 1 -->
                <div v-if="person2">
                  <v-row>
                    <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                      <v-text-field
                        v-model="newPersonInvolved2"
                        label="Name of Person Involved"
                      ></v-text-field>
                    </v-col>

                    <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                      <v-text-field
                        v-model="newTitle2"
                        label="Title"
                      ></v-text-field>
                    </v-col>

                    <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                      <v-text-field
                        v-model="newPhone2"
                        label="Phone Number"
                      ></v-text-field>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="12" md="4">
                      <v-select
                        v-model="newRoles2"
                        label="Persons Role"
                        :items="roles"
                      ></v-select>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="12" md="4">
                      <v-select
                        v-model="newInvolvement2"
                        label="Persons Involvement Role"
                        :items="involvement"
                      ></v-select>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="12" md="4">
                      <v-btn @click="person3 = 'true'"
                        >Add Another Person</v-btn
                      >
                    </v-col>
                  </v-row>
                </div>
                <!-- end of person 2 -->

                <div v-if="person3">
                  <v-row>
                    <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                      <v-text-field
                        v-model="newPersonInvolved3"
                        label="Name of Person Involved"
                      ></v-text-field>
                    </v-col>

                    <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                      <v-text-field
                        v-model="newTitle3"
                        label="Title"
                      ></v-text-field>
                    </v-col>

                    <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                      <v-text-field
                        v-model="newPhone3"
                        label="Phone Number"
                      ></v-text-field>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="12" md="4">
                      <v-select
                        v-model="newRoles3"
                        label="Persons Role"
                        :items="roles"
                      ></v-select>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="12" md="4">
                      <v-select
                        v-model="newInvolvement3"
                        label="Persons Involvement Role"
                        :items="involvement"
                      ></v-select>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="12"></v-col>
                  </v-row>
                </div>
                <!-- end of person 3 -->

                <v-col
                  cols="12"
                  class="white--text text-uppercase text-center"
                  style="background-color: #2b3990; border-radius: 10px"
                  >Parties Notified</v-col
                >

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-model="newOrganization1"
                    label="Organization"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-model="newOrgPhone1"
                    label="Phone"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-select
                    v-model="newOrgType1"
                    label="Organization"
                    :items="organization"
                  ></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-model="newOrgFullName1"
                    label="Full Name"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-model="newOrgTitle1"
                    label="Title"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-menu offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="newOrgNotDate1"
                        label="Notification Date"
                        v-on="on"
                        prepend-icon="events"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newOrgNotDate1"
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-model="newOrgCaseNum1"
                    label="Case Number"
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  class="white--text text-uppercase text-center"
                  style="background-color: #2b3990; border-radius: 10px"
                  >Incident Involved (Select All That Apply)</v-col
                >

                <v-col cols="12" sm="6">
                  <span class="font-weight-bold">Incident Involved</span>

                  <v-checkbox
                    v-model="hospital"
                    label="Hospital Admission"
                    value="Hospital Admission"
                  ></v-checkbox>
                  <div v-if="hospital" class="grey lighten-3 pa-5 ml-5">
                    <v-text-field
                      v-model="newHospitalName"
                      label="Hospital Name"
                    ></v-text-field>
                    <v-datetime-picker
                      v-model="newHospitalDate"
                      label="Admission Date"
                    ></v-datetime-picker>
                    <div class="mt-5 text-uppercase">Facility Type</div>
                    <v-item-group>
                      <v-switch
                        v-model="newFacilityType"
                        label="Hospital"
                        value="Hospital"
                      ></v-switch>
                      <v-switch
                        v-model="newFacilityType"
                        label="Psychiatric Unit/Facility"
                        value="Psychiatric Unit/Facility"
                      ></v-switch>
                      <v-switch
                        v-model="newFacilityType"
                        label="Other (describe)"
                        value="Other (describe)"
                      ></v-switch>
                    </v-item-group>
                    <v-text-field
                      v-if="newFacilityType == 'Other (describe)'"
                      label="Other details"
                      v-model="newOtherHospital"
                    ></v-text-field>
                  </div>

                  <v-checkbox
                    v-model="lawEnforcement"
                    label="Law Enforcement"
                    value="Law Enforcement"
                  ></v-checkbox>
                  <div v-if="lawEnforcement" class="grey lighten-3 pa-5 ml-5">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-switch
                            v-model="newLaw"
                            label="Charges Filed"
                            value="Charges Filed"
                          ></v-switch>
                          <v-switch
                            v-model="newLaw"
                            label="Citation Issued"
                            value="Citation Issued"
                          ></v-switch>
                          <v-switch
                            v-model="newLaw"
                            label="Client Arrested"
                            value="Client Arrested"
                          ></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-switch
                            v-model="newLaw"
                            label="Client Taken to Jail"
                            value="Client Taken to Jail"
                          ></v-switch>
                          <v-switch
                            v-model="newLaw"
                            label="Police Called"
                            value="Police Called"
                          ></v-switch>
                          <v-switch
                            v-model="newLaw"
                            label="Police Talked to Client"
                            value="Police Talked to Client"
                          ></v-switch>
                          <v-switch
                            v-model="newLaw"
                            label="Other (describe)"
                            value="Other (describe)"
                          ></v-switch>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <v-text-field
                            v-if="newLaw == 'Other (describe)'"
                            label="Other details"
                            v-model="newOtherLaw"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>

                    <v-text-field
                      v-if="otherLaw"
                      label="Other details"
                    ></v-text-field>
                  </div>

                  <v-checkbox
                    v-model="medicalCare"
                    label="Medical Care"
                    value="Medical Care"
                  ></v-checkbox>
                  <div v-if="medicalCare" class="grey lighten-3 pa-5 ml-5">
                    <v-container>
                      <span>Select all that apply</span>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-switch
                            v-model="new911Call"
                            label="911 Called"
                            value="911 Called"
                          ></v-switch>
                          <v-switch
                            v-model="newMedicalClinic"
                            label="Client Taken to Medical Clinic"
                            value="Client Taken to Medical Clinic"
                          ></v-switch>
                          <v-switch
                            v-model="newER"
                            label="Client Taken to ER"
                            value="Client Taken to ER"
                          ></v-switch>
                          <v-switch
                            v-model="newAssessedClient"
                            label="Crisis Staff Assessed Client"
                            value="Crisis Staff Assessed Client"
                          ></v-switch>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-switch
                            v-model="newFirstAid"
                            label="First Aid Adiministered"
                            value="First Aid Adiministered"
                          ></v-switch>
                          <v-switch
                            v-model="newPoison"
                            label="Poison Control Contacted"
                            value="Poison Control Contacted"
                          ></v-switch>
                          <v-switch
                            v-model="newNurseContacted"
                            label="Provider Nurse Contacted"
                            value="Provider Nurse Contacted"
                          ></v-switch>
                          <v-switch
                            label="Other (describe)"
                            v-model="otherMedical"
                            value="Other (describe)"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-text-field
                      v-if="otherMedical == 'Other (describe)'"
                      label="Other details"
                      v-model="newOtherMedical"
                    ></v-text-field>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  class="white--text text-uppercase text-center"
                  style="background-color: #2b3990; border-radius: 10px"
                  >Incident Category (Select All That Apply)</v-col
                >

                <v-row>
                  <v-col cols="12" sm="12">
                    <v-select
                      multiple
                      :items="incidentCategory"
                      label="Select all that apply"
                      v-model="newIncidentCategory"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <div
                      v-if="
                        newIncidentCategory.includes(
                          'Abuse/Neglect/Exploitation'
                        )
                      "
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-2"
                        >
                          <h2>Abuse Category</h2>
                          <v-switch
                            v-model="newAbuseCategory"
                            label="Emotional"
                            value="Emotional"
                          ></v-switch>
                          <v-switch
                            v-model="newAbuseCategory"
                            label="Financial"
                            value="Financial"
                          ></v-switch>
                          <v-switch
                            v-model="newAbuseCategory"
                            label="Physical"
                            value="Physical"
                          ></v-switch>
                          <v-switch
                            v-model="newAbuseCategory"
                            label="Exploitation"
                            value="Exploitation"
                          ></v-switch>
                          <v-switch
                            v-model="newAbuseCategory"
                            label="Neglect"
                            value="Neglect"
                          ></v-switch>
                          <v-switch
                            v-model="newAbuseCategory"
                            label="Sexual"
                            value="Sexual"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="2"
                          class="grey lighten-4 pa-5 ma-2"
                        >
                          <h2>Abuse Type</h2>
                          <v-switch
                            v-model="newAbuseType"
                            label="Observed"
                            value="Observed"
                          ></v-switch>
                          <v-switch
                            v-model="newAbuseType"
                            label="Suspected"
                            value="Suspected"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-2"
                        >
                          <h2>Client Role in Abuse</h2>
                          <v-switch
                            v-model="newClientRole"
                            label="Perpetrator"
                            value="Perpetrator"
                          ></v-switch>
                          <v-switch
                            v-model="newClientRole"
                            label="Victim"
                            value="Victim"
                          ></v-switch>
                          <v-switch
                            v-model="newClientRole"
                            label="Perpetrator and Victim"
                            value="Perpetrator and Victim"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-2"
                        >
                          <h2>Protective Services Notified</h2>
                          <v-switch
                            v-model="newProtectiveNotified"
                            label="Yes"
                            value="Yes"
                          ></v-switch>
                          <v-switch
                            v-model="newProtectiveNotified"
                            label="No"
                            value="No"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div
                      v-if="newIncidentCategory.includes('Aspiration/Choking')"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-2"
                        >
                          <h2>Type of Incident</h2>
                          <v-switch
                            v-model="newChokingType"
                            label="Choking"
                            value="Choking"
                          ></v-switch>
                          <v-switch
                            v-model="newChokingType"
                            label="Aspiration"
                            value="Aspiration"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="4"
                          class="grey lighten-4 pa-5 ma-2"
                        >
                          <h2>Aspirated/Choked Item</h2>
                          <v-switch
                            v-model="newChokedItem"
                            label="Food"
                            value="Food"
                          ></v-switch>
                          <v-switch
                            v-model="newChokedItem"
                            label="Liquid"
                            value="Liquid"
                          ></v-switch>
                          <v-switch
                            v-model="newChokedItem"
                            label="Object"
                            value="Object"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="4"
                          class="grey lighten-4 pa-5 ma-2"
                        >
                          <v-text-field
                            v-model="newChokingActions"
                            label="Action Taken for Aspiration/Choking"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div
                      v-if="
                        newIncidentCategory.includes('Behavior Intervention')
                      "
                    >
                      <v-row>
                        <v-col cols="12" sm="6" class="grey lighten-4 pa-5">
                          <v-textarea
                            v-model="newInterventionCircumstances"
                            label="Intervention Circumstances"
                            outlined
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" class="grey lighten-4 pa-5">
                          <v-textarea
                            v-model="newInterventionJustification"
                            label="Intervention Justification"
                            outlined
                          ></v-textarea>
                        </v-col>
                        <v-col col="12" sm="6" class="grey lighten-4 pa-5">
                          <h2>Intervention Cause</h2>
                          <v-switch
                            v-model="newInterventionCause"
                            label="Aggression Toward Other People"
                            value="Aggression Toward Other People"
                          ></v-switch>
                          <v-switch
                            v-model="newInterventionCause"
                            label="Aggression Toward Client(s)"
                            value="Aggression Toward Client(s)"
                          ></v-switch>
                          <v-switch
                            v-model="newInterventionCause"
                            label="Property Destruction"
                            value="Property Destruction"
                          ></v-switch>
                          <v-switch
                            v-model="newInterventionCause"
                            label="Self-Injurious Behavior"
                            value="Self-Injurious Behavior"
                          ></v-switch>
                          <v-switch
                            v-model="newInterventionCause"
                            label="Other (describe)"
                            value="Other (describe)"
                          ></v-switch>
                          <v-text-field
                            v-if="newInterventionCause == 'Other (describe)'"
                            label="Other Detail"
                          ></v-text-field>
                          <v-datetime-picker
                            v-model="newInterventionDate"
                            label="Intervention Start Date"
                          ></v-datetime-picker>
                          <v-text-field
                            v-model="newInterventionDuration"
                            label="Intervention Duration"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="grey lighten-4 pa-5">
                          <h3>
                            **Physical restraints should not exceed 5 minutes;
                            however, additional restraints may be required.
                            Indicate number of restraints implemented and
                            duration of each restraint.
                          </h3>
                          <v-text-field
                            v-model="newFirstIntervention"
                            label="First Intervention Duration (# of minutes)"
                          ></v-text-field>
                          <v-text-field
                            v-model="newSecondIntervention"
                            label="Second Intervention Duration (# of minutes)"
                          ></v-text-field>
                          <v-text-field
                            v-model="newThirdIntervention"
                            label="Third Intervention Duration (# of minutes)"
                          ></v-text-field>
                          <v-text-field
                            v-model="newFourthIntervention"
                            label="Fourth Intervention Duration (# of minutes)"
                          ></v-text-field>
                          <v-text-field
                            v-model="newFifthIntervention"
                            label="Fifth Intervention Duration (# of minutes)"
                          ></v-text-field>
                          <v-textarea
                            v-model="newAdditionalRestraints"
                            outlined
                            label="Additional Restraints"
                          ></v-textarea>
                          <v-text-field
                            v-model="newAdditonalMinutes"
                            label="Additional # of Minutes"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col col="12" sm="4" class="grey lighten-4 pa-5">
                          <h2>Intervention Used</h2>
                          <v-switch
                            v-model="newInterventionUsed"
                            label="Enforced Compliance"
                            value="Enforced Compliance"
                          ></v-switch>
                          <v-switch
                            v-model="newInterventionUsed"
                            label="Physical Requirements"
                            value="Physical Requirements"
                          ></v-switch>
                          <v-switch
                            v-model="newInterventionUsed"
                            label="Mechanical Restraints"
                            value="Mechanical Restraints"
                          ></v-switch>
                          <v-switch
                            v-model="newInterventionUsed"
                            label="Restriction By People"
                            value="Restriction By People"
                          ></v-switch>
                          <v-switch
                            v-model="newInterventionUsed"
                            label="Seclusion Room"
                            value="Seclusion Room"
                          ></v-switch>
                          <v-switch
                            v-model="newInterventionUsed"
                            label="Unwanted Restrictions"
                            value="Unwanted Restrictions"
                          ></v-switch>
                          <v-switch
                            v-model="newInterventionUsed"
                            label="Other (describe)"
                            value="Other (describe)"
                          ></v-switch>
                          <v-text-field
                            v-if="newInterventionUsed == 'Other (describe)'"
                            label="Other details"
                          ></v-text-field>
                          <div
                            v-if="
                              newInterventionUsed == 'Physical Requirements'
                            "
                          >
                            <span>Safety Care Restraint Used</span>
                            <v-checkbox
                              v-model="newOnePerson"
                              label="One Person Restraint"
                              value="One Person Restraint"
                            ></v-checkbox>
                            <v-checkbox
                              v-model="newTwoPerson"
                              label="Two Person Restraint"
                              value="Two Person Restraint"
                            ></v-checkbox>
                            <v-checkbox
                              v-model="newMultiplePerson"
                              label="Multiple Person Restraint"
                              value="Multiple Person Restraint"
                            ></v-checkbox>
                            <v-checkbox
                              v-model="newFloorRestraint"
                              label="Floor Restraint"
                              value="Floor Person Restraint"
                            ></v-checkbox>
                            <v-checkbox
                              v-model="newTransportRestraint"
                              label="Transport Restraint"
                              value="Transport Restraint"
                            ></v-checkbox>
                          </div>
                        </v-col>
                        <v-col col="12" sm="4" class="grey lighten-4 pa-5">
                          <h2>Intervention in Behavior Support Plan</h2>
                          <v-switch
                            v-model="newInterventionPlan"
                            label="Yes"
                            value="Yes"
                          ></v-switch>
                          <v-switch
                            v-model="newInterventionPlan"
                            label="No"
                            value="No"
                          ></v-switch>
                        </v-col>
                        <v-col col="12" sm="4" class="grey lighten-4 pa-5">
                          <h2>Behavior Specialist Notified?</h2>
                          <v-switch
                            v-model="newBehaviorSpecialist"
                            label="Yes"
                            value="Yes"
                          ></v-switch>
                          <v-switch
                            v-model="newBehaviorSpecialist"
                            label="No"
                            value="No"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div
                      v-if="
                        newIncidentCategory.includes('Compromised Environment')
                      "
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          sm="4"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Compromised Environment Type</h2>
                          <v-switch
                            v-model="newEnvironment"
                            label="Living"
                            value="Living"
                          ></v-switch>
                          <v-switch
                            v-model="newEnvironment"
                            label="Working/Day"
                            value="Working/Day"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="4"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Action Taken</h2>
                          <v-switch
                            v-model="newEvacuated"
                            label="Not Evacuated"
                            value="Not Evacuated"
                          ></v-switch>
                          <v-switch
                            v-model="newEvacuated"
                            label="Evacuated"
                            value="Evacuated"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>New Location (if applicable)</h2>
                          <v-text-field
                            v-model="newLocation"
                            label="New Location"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div v-if="newIncidentCategory.includes('Drug/Alcohol')">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Substance Type (Select all that apply)</h2>
                          <v-switch
                            v-model="newSubAlcohol"
                            label="Alcohol"
                            value="Alcohol"
                          ></v-switch>
                          <v-switch
                            v-model="newSubDrugs"
                            label="Illegal Drugs"
                            value="Illegal Drugs"
                          ></v-switch>
                          <v-switch
                            v-model="newSubMedications"
                            label="Over the Counter Medication"
                            value="Over the Counter Medication"
                          ></v-switch>
                          <v-switch
                            v-model="newSubPrescriptions"
                            label="Prescription Medication"
                            value="Prescription Medication"
                          ></v-switch>
                          <v-switch
                            v-model="newSOther"
                            label="Other (describe)"
                            value="Other (describe)"
                          ></v-switch>
                          <v-text-field
                            v-model="newSubOther"
                            label="Other details"
                            v-if="newSOther == 'Other (describe)'"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div v-if="newIncidentCategory.includes('Fatality')">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Fatality Status</h2>
                          <v-switch
                            v-model="newFatality"
                            label="Expected"
                            value="Expected"
                          ></v-switch>
                          <v-switch
                            v-model="newFatality"
                            label="Not Expected"
                            value="Not Expected"
                          ></v-switch>
                          <v-switch
                            v-model="newFatality"
                            label="Not Applicable"
                            value="Not Applicable"
                          ></v-switch>
                          <div v-if="newFatality == 'Not Expected'">
                            <v-switch
                              v-model="newUnexpected"
                              label="Homicide"
                            ></v-switch>
                            <v-switch
                              v-model="newUnexpected"
                              label="Suicide"
                            ></v-switch>
                            <v-switch
                              v-model="newUnexpected"
                              label="Other (describe)"
                            ></v-switch>
                            <v-text-field
                              v-if="newUnexpected == 'Other (describe)'"
                              v-model="newFatalityOther"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Was the Client Receiving Hospice Care</h2>
                          <v-switch
                            v-model="newHospice"
                            label="Yes"
                            value="Yes"
                          ></v-switch>
                          <v-switch
                            v-model="newHospice"
                            label="No"
                            value="No"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div v-if="newIncidentCategory.includes('Injury')">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Injured Body Parts (Select All That Apply)</h2>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <v-switch
                            v-model="newAbdomen"
                            label="Abdomen"
                            value="Abdomen"
                          ></v-switch>
                          <v-switch
                            v-model="newBack"
                            label="Back"
                            value="Back"
                          ></v-switch>
                          <v-switch
                            v-model="newButtocks"
                            label="Buttocks"
                            value="Buttocks"
                          ></v-switch>
                          <v-switch
                            v-model="newChest"
                            label="Chest"
                            value="Chest"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <v-switch
                            v-model="newFace"
                            label="Face"
                            value="Face"
                          ></v-switch>
                          <v-switch
                            v-model="newGenitals"
                            label="Genitals"
                            value="Genitals"
                          ></v-switch>
                          <v-switch
                            v-model="newHead"
                            label="Head"
                            value="Head"
                          ></v-switch>
                          <v-switch
                            v-model="newNeck"
                            label="Neck"
                            value="Neck"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <v-switch
                            v-model="newPelvis"
                            label="Pelvis"
                            value="Pelvis"
                          ></v-switch>
                          <v-switch
                            v-model="newLeftAnkle"
                            label="Left Ankle"
                            value="Left Ankle"
                          ></v-switch>
                          <v-switch
                            v-model="newLeftArm"
                            label="Left Arm"
                            value="Left Arm"
                          ></v-switch>
                          <v-switch
                            v-model="newLeftFoot"
                            label="Left Foot"
                            value="Left Foot"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <v-switch
                            v-model="newLeftHand"
                            label="Left Hand"
                            value="Left Hand"
                          ></v-switch>
                          <v-switch
                            v-model="newLeftKnee"
                            label="Left Knee"
                            value="Left Knee"
                          ></v-switch>
                          <v-switch
                            v-model="newLeftLeg"
                            label="Left Leg"
                            value="Left Leg"
                          ></v-switch>
                          <v-switch
                            v-model="newLeftShoulder"
                            label="Left Shoulder"
                            value="Left Shoulder"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <v-switch
                            v-model="newLeftWrist"
                            label="Left Wrist"
                            value="Left Wrist"
                          ></v-switch>
                          <v-switch
                            v-model="newLeftHip"
                            label="Left Hip"
                            value="Left Hip"
                          ></v-switch>
                          <v-switch
                            v-model="newRightAnkle"
                            label="Right Ankle"
                            value="Right Ankle"
                          ></v-switch>
                          <v-switch
                            v-model="newRightArm"
                            label="Right Arm"
                            value="Right Arm"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <v-switch
                            v-model="newRightFoot"
                            label="Right Foot"
                            value="Right Foot"
                          ></v-switch>
                          <v-switch
                            v-model="newRightHand"
                            label="Right Hand"
                            value="Right Hand"
                          ></v-switch>
                          <v-switch
                            v-model="newRightKnee"
                            label="Right Knee"
                            value="Right Knee"
                          ></v-switch>
                          <v-switch
                            v-model="newRightShoulder"
                            label="Right Shoulder"
                            value="Right Shoulder"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <v-switch
                            v-model="newRightWrist"
                            label="Right Wrist"
                            value="Right Wrist"
                          ></v-switch>
                          <v-switch
                            v-model="newRightHip"
                            label="Right Hip"
                            value="Right Hip"
                          ></v-switch>
                          <v-switch
                            v-model="newOther"
                            label="Other (describe)"
                            value="Other (describe)"
                          ></v-switch>
                          <v-text-field
                            v-model="newInjuredOther"
                            v-if="newOther == 'Other (describe)'"
                            label="Other details"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="3"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Client's Role in Injury</h2>
                          <v-switch
                            v-model="newInjuryRole"
                            label="Perpetrator"
                            value="Perpetrator"
                          ></v-switch>
                          <v-switch
                            v-model="newInjuryRole"
                            label="Victim"
                            value="Victim"
                          ></v-switch>
                          <v-switch
                            v-model="newInjuryRole"
                            label="Victim and Perpetrator"
                            value="Victim and Perpetrator"
                          ></v-switch>
                          <h2>Self-Inflicted Injury</h2>
                          <v-switch
                            v-model="newSelfInflicted"
                            label="Yes"
                            value="Yes"
                          ></v-switch>
                          <v-switch
                            v-model="newSelfInflicted"
                            label="No"
                            value="No"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div
                      v-if="newIncidentCategory.includes('Medication Errors')"
                    >
                      <v-row>
                        <v-col cols="12" class="grey lighten-4 pa-5 ma-1">
                          <h2>Medication(s) Involved</h2>
                          <v-text-field
                            label="Medications Involved"
                            v-model="newMedicationsInvolved"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="grey lighten-4 pa-5 ma-1">
                          <h2>Medication Error Type</h2>
                          <v-switch
                            label="Missed Dose"
                            value="Missed Dose"
                            v-model="newMedicationError"
                          ></v-switch>
                          <v-switch
                            label="Overdose"
                            value="Overdose"
                            v-model="newMedicationError"
                          ></v-switch>
                          <v-switch
                            label="Underdose"
                            value="Underdose"
                            v-model="newMedicationError"
                          ></v-switch>
                          <v-switch
                            label="Wrong Medication"
                            value="Wrong Medication"
                            v-model="newMedicationError"
                          ></v-switch>
                          <v-switch
                            label="Other (describe)"
                            value="Other (describe)"
                            v-model="newMedicationError"
                          ></v-switch>
                          <v-text-field
                            label="Other details"
                            v-model="newMedicationErrOther"
                            v-if="newMedicationError == 'Other (describe)'"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div v-if="newIncidentCategory.includes('Missing Person')">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Client Last Seen Date/Time</h2>
                          <v-menu offset-y min-width="290px" max-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :value="newLastSeen"
                                label="Client Last Seen"
                                v-on="on"
                                prepend-icon="events"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="newLastSeen"
                              scrollable
                            ></v-date-picker>
                          </v-menu>

                          <v-text-field
                            label="Client Last Seen Location"
                            v-model="newLastLocation"
                          ></v-text-field>

                          <v-menu offset-y min-width="290px" max-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                :value="newDiscovered"
                                label="Client Discovered Missing Date/Time"
                                v-on="on"
                                prepend-icon="events"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="newDiscovered"
                              scrollable
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Missing Person Unexplained Circumstatnces</h2>
                          <v-switch
                            label="Yes"
                            value="Yes"
                            v-model="newUnexplained"
                          ></v-switch>
                          <v-switch
                            label="No"
                            value="No"
                            v-model="newUnexplained"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Missing Person Involuntary Circumstances</h2>
                          <v-switch
                            label="Yes"
                            value="Yes"
                            v-model="newInvoluntary"
                          ></v-switch>
                          <v-switch
                            label="No"
                            value="No"
                            v-model="newInvoluntary"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Missing Person Suspicious Circumstances</h2>
                          <v-switch
                            label="Yes"
                            value="Yes"
                            v-model="newSuspicious"
                          ></v-switch>
                          <v-switch
                            label="No"
                            value="No"
                            v-model="newSuspicious"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Client Found</h2>
                          <v-switch
                            label="Yes"
                            value="Yes"
                            v-model="newFound"
                          ></v-switch>
                          <v-switch
                            label="No"
                            value="No"
                            v-model="newFound"
                          ></v-switch>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          class="grey lighten-4 pa-5 ma-1"
                        >
                          <h2>Current Living Status</h2>
                          <v-text-field
                            label="Living Status"
                            v-model="newLivingStatus"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div
                      v-if="
                        newIncidentCategory.includes('Property Destruction')
                      "
                    >
                      <v-col cols="12" sm="12" class="grey lighten-4 pa-5 ma-1">
                        <h2>Damaged Item</h2>
                        <v-text-field
                          label="Damaged Item Name"
                          v-model="newDamagedItem"
                        ></v-text-field>
                        <v-file-input
                          label="Photo"
                          v-model="newDamagedPhoto"
                        ></v-file-input>
                        <v-text-field
                          label="Owner of Damaged Property"
                          v-model="newPropertyOwner"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" class="grey lighten-4 pa-5 ma-1">
                        <h2>Action Taken for Property Damage</h2>
                        <v-switch
                          class="No Action"
                          value="No Action"
                          label="No Action"
                          v-model="newPropertyAction"
                        ></v-switch>
                        <v-switch
                          class="Repair"
                          value="Repair"
                          label="Repair"
                          v-model="newPropertyAction"
                        ></v-switch>
                        <v-switch
                          class="Replace"
                          value="Replace"
                          label="Replace"
                          v-model="newPropertyAction"
                        ></v-switch>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div v-if="newIncidentCategory.includes('Seizure')">
                      <v-col cols="12" sm="12" class="grey lighten-4 pa-5 ma-1">
                        <h2>Describe the Seizure</h2>
                        <v-textarea
                          label="Description"
                          outlined
                          v-model="newSeizureDescription"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" class="grey lighten-4 pa-5 ma-1">
                        <h2>Does the Client Have a Seizure Diagnosis?</h2>
                        <v-switch
                          label="Yes"
                          value="Yes"
                          v-model="newSeizureDiagnosis"
                        ></v-switch>
                        <v-switch
                          label="No"
                          value="No"
                          v-model="newSeizureDiagnosis"
                        ></v-switch>
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="date"
                              label="Picker in menu"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="date" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu = false">
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu.save(date)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-text-field
                          label="Seizure Duration (in minutes)"
                          v-model="newSeizureDuration"
                        ></v-text-field>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div
                      v-if="
                        newIncidentCategory.includes('Suicide Attempt/Threat')
                      "
                    >
                      <v-col cols="12" sm="12" class="grey lighten-4 pa-5 ma-1">
                        <h2>Suicide Type</h2>
                        <v-switch
                          label="Attempt"
                          value="Attempt"
                          v-model="newSuicideType"
                        ></v-switch>
                        <v-switch
                          label="Threat"
                          value="Threat"
                          v-model="newSuicideType"
                        ></v-switch>
                        <v-textarea
                          outlined
                          label="Suicide Attempt/Threat Description"
                          v-model="newSuicideDescription"
                        ></v-textarea>
                        <v-textarea
                          outlined
                          label="Actions Taken for Suicide"
                          hint="Should include efforts to monitor client for further suicidal thoughts and/or behavior"
                          v-model="newSuicideActions"
                        ></v-textarea>
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div
                      v-if="newIncidentCategory.includes('Other (describe)')"
                    >
                      <v-col cols="12" sm="12" class="grey lighten-4 pa-5 ma-1">
                        <h2>Other</h2>

                        <v-textarea
                          outlined
                          label="Other details"
                          v-model="newDetailsOther"
                        ></v-textarea>
                      </v-col>
                    </div>
                  </v-col>
                </v-row>

                <v-col
                  cols="12"
                  class="white--text text-uppercase text-center"
                  style="background-color: #2b3990; border-radius: 10px"
                >
                  Document Upload
                </v-col>

                <v-col cols="12" sm="6">
                  <v-file-input
                    v-model="newDocument"
                    class="pa-2"
                    label="Select documents to upload"
                    show-size
                    filled
                    multiple
                    prepend-icon="mdi-camera"
                    accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    @change="fileSelected"
                  >
                    <template #selection="{ text, index }">
                      <v-chip
                        small
                        label
                        close
                        color="primary"
                        @click:close="deleteChip(index)"
                        >{{ text }}</v-chip
                      >
                    </template>
                  </v-file-input>
                </v-col>

                <v-col
                  cols="12"
                  class="white--text text-uppercase text-center"
                  style="background-color: #2b3990; border-radius: 10px"
                  >Detailed Description of Incident</v-col
                >

                <v-col cols="12"
                  >**Please provide a detailed and specific third-person
                  description of the incident, including what circumstances and
                  antecedents that led up to the incident and/or seemed to cause
                  the incident, how each person was involved, what Safety Care
                  technique was utilized (i.e., one-hand/two-hand wrist grab
                  release, one-hand/two-hand hair pull release, back/front choke
                  release, bite release), what specific Safety Care restraint
                  was utilized (i.e., One Person Restraint, Two Person
                  Restraint, Multiple Person Restraint, Transport Restraint or
                  any Floor Restraints), how the client was verbally or
                  physically redirected (e.g., “staff verbally prompted client
                  to discontinue harmful behavior,” “staff placed arm around
                  shoulder of client and escorted her away from the group”), and
                  the outcome of the incident. The description should simply
                  state the facts of what occurred and should not provide
                  information that reflects or states an opinion. If the
                  incident involved a suicidal threat and/or attempt, include
                  information regarding efforts made by staff to monitor the
                  client for any further indications of suicidal thoughts and/or
                  behavior.</v-col
                >

                <v-col class="d-flex" cols="12" sm="12">
                  <v-textarea
                    v-model="newCircumstances"
                    label="Circumstances Leading up to Incident"
                    outlined
                  ></v-textarea>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-textarea
                    v-model="newIncidentDescription"
                    label="Incident Description"
                    outlined
                  ></v-textarea>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-textarea
                    v-model="newOutcome"
                    label="Outcome of the Incident"
                    outlined
                  ></v-textarea>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-textarea
                    v-model="newStaffAssessment"
                    label="Staff Self Assessment"
                    outlined
                  ></v-textarea>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-checkbox
                    label="Staff Signature"
                    @click="addStaffSignature()"
                  ></v-checkbox>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-text-field
                    v-if="staffSignature"
                    v-model="newStaffSignature"
                    label="Signature of Person Initiating Report"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Phone"
                    v-model="newStaffPhone"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6"></v-col>

                <v-col
                  cols="12"
                  class="white--text text-uppercase text-center"
                  style="background-color: #2b3990; border-radius: 10px"
                  >Supervisor Use Only</v-col
                >

                <v-col class="d-flex" cols="12" sm="12">
                  <v-checkbox
                    label="Supervisor Signature"
                    @click="addSignature()"
                  ></v-checkbox>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-if="supervisorSignature"
                    v-model="newSupervisorSignature"
                    label="Signed By"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                    v-model="newSupervisorPhone"
                    label="Supervisor Phone"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6"></v-col>

                <v-col
                  cols="12"
                  class="white--text text-uppercase text-center"
                  style="background-color: #2b3990; border-radius: 10px"
                  >Supervisors Manager</v-col
                >

                <v-col cols="12">
                  <v-checkbox
                    label="Supervisors Manager Signature"
                    @click="addManagerSignature()"
                  ></v-checkbox>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                    v-if="managerSignature"
                    v-model="newManagerSignature"
                    label="Supervisor Name"
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                    v-model="newSupportCoordinator"
                    label="Support Coordinator"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6"></v-col>

                <v-col cols="12">
                  <h3>Support Coordinator Notified</h3>
                  <v-switch label="Yes" value="Yes"></v-switch>
                  <v-switch label="No" value="No"></v-switch>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-text-field label="Guardian Name"></v-text-field>
                  <h3>Guardian Notified?</h3>
                  <v-switch label="Yes" value="Yes"></v-switch>
                  <v-switch label="No" value="No"></v-switch>
                </v-col>

                <v-col
                  cols="12"
                  class="white--text text-uppercase text-center"
                  style="background-color: #2b3990; border-radius: 10px"
                  >For Administrative Use Only</v-col
                >

                <v-col cols="12" sm="6">
                  <v-menu offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="newReportReceived"
                        label="Incident Report Received"
                        v-on="on"
                        prepend-icon="events"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newReportReceived"
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6"></v-col>
                <v-col class="d-flex" cols="12" sm="6">
                  <h3>Report Reviewed By</h3>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-checkbox
                    @click="addReviewedSignature()"
                    label="Signature"
                  ></v-checkbox>
                  <v-text-field
                    v-if="reviewedSignature"
                    label="Report Reviewed By"
                    v-model="newReviewedSignature"
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                    v-model="newAdminTitle"
                    label="Title"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6"></v-col>
                <v-col cols="12" sm="12">
                  <h3>DSPD/OL Notification Submitted</h3>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <h3>
                    DSPD clients need to be uploaded to UPI and DCFS clients
                    need to be uploaded to Office of Licensing (OL).
                  </h3>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-switch
                    v-model="newNotificationSubmitted"
                    label="Yes"
                    value="Yes"
                  ></v-switch>
                  <v-switch
                    v-model="newNotificationSubmitted"
                    label="No"
                    value="No"
                  ></v-switch>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <h3>DSPD/OL Report Submitted</h3>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-switch
                    v-model="newReportSubmitted"
                    label="Yes"
                    value="Yes"
                  ></v-switch>
                  <v-switch
                    v-model="newReportSubmitted"
                    label="No"
                    value="No"
                  ></v-switch>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12">
                  <v-textarea
                    v-model="newAdministrativeNotes"
                    label="Administrative Notes"
                    outlined
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            color="#259647"
            @click="addIncidentReport()"
            >Save</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="closeCreateIncidentReportDialog"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/*eslint-disable */
import moment from "moment";
import axios from "axios";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { setUserSignatureTz } from "../../../../utils/timezone";
import ShareLink from "@/components/shared/ShareLink";
import ConfirmationDialog from "@/components/shared/ConfirmationDialog";
import SkinCheckImageUploadDialog from "@/components/serviceplan/adl/skinCheckImageUpload";
import ViewSkinCheckImages from "@/components/serviceplan/adl/ViewImages";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const shareUrl = require("@/client_config/config").shareUrl;
const url = require("../../../client_config/config").url;

export default {
  components: {
    ShareLink,
    ConfirmationDialog,
    SkinCheckImageUploadDialog,
    ViewSkinCheckImages,
    ValidationProvider, 
    ValidationObserver
  },
  props: {
    morningServices: {
      type: Array,
    },
    afternoonServices: {
      type: Array,
    },
    eveningServices: {
      type: Array,
    },
    prnServices: {
      type: Array,
    },
    isAuditorRole: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      headers: [
        { text: "Incident Date", value: "IncidentDateTimeTable" },
        { text: "Program", value: "Program" },
        { text: "Incident Location", value: "IncidentLocation" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      newAssistance: "",
      newException: "",
      newNotes: "",
      newSignature: "",
      newService: "",
      newTableKey: "",
      reveal: false,
      multipleSelectedItem: false,
      shareLinkDialog: false,
      confirmationDialog: false,
      selectedIndex: [],
      selectedADL: [],
      cardIndex: null,
      isSaving: false,
      clientID: null,
      userName: localStorage.getItem("Name"),
      msg: false,
      color: "",
      text: "",
      isLoading: true,
      assistance: [
        "Independant",
        "Minimal Assistance",
        "Moderate Assistance",
        "Total Assistance",
      ],
      injuryItems: ["Yes", "No"],
      isRequiredSkinCheck: ["Yes", "No"],
      followUpItems: ["Yes", "No"],
      selectedSkinRequiredItem: null,
      selectedInjuryItem: "",
      selectedFollowUpItem: "",
      selectedDaysOfFollowUp: "",
      selectedTimeToBeCompleted: "",
      selectedServiceItem: "",
      followUpServiceItem: "Skin Check",
      followUpType: ["Morning", "Afternoon", "Night"],
      followUpProvider: [
        "Behaviorist",
        "CNA",
        "Cook",
        "Direct Care Staff",
        "Housekeeper",
        "Nurse",
        "Program Manager",
        "Yard Maintenance",
      ],
      followUpLoa: [
        "Independent",
        "Minimal Assistance",
        "Moderate Assistance",
        "Total Assistance",
      ],
      followUpDays: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      followUpDescription: "This is a follow up service plan for skin check.",
      followUpMenu: false,
      followUpMenu2: false,
      followUpDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      followUpStartDate: moment(new Date()).format("YYYY-MM-DD"),
      followUpEndDate: moment(new Date()).format("YYYY-MM-DD"),
      followUpStatus: ["Active", "Disabled"],
      selectedFollowUpType: "",
      selectedFollowUpProvider: "",
      selectedFollowUpLoa: "",
      selectedFollowUpDays: "",
      selectedFollowUpStatus: "",
      exception: ["Refused", "ADL on Hold", "Absent", "Other"],
      tableKey: [
        "Prompts Needed",
        "Participated",
        "Refused",
        "Home Visit",
        "Absent",
        "Yes",
        "No",
      ],
      schedule: {
        morning: "Morning",
        afternoon: "Afternoon",
        evening: "Evening",
        daily: "Daily/PRN",
      },
      exceptionDialog: false,
      isClear: false,
      signed: false,
      error: null,
      generatedURL: "",
      isUploadDialogOpen: false,
      isFollowUpDialogOpen: false,
      isOpenServicePlanAttachmentsDialog: false,
      isOpenCreateIncidentReportDialog: false,
      skinCheckUploadProgress: 0,
      requiredRulesForFollowUp: [(v) => !!v || "This is required"],
      selectedFiles: [],
      attachments: [],
      selectedServicePlan: {},
      isUploadingSkinCheckImage: false,
      titleForm: "New Incident",
      humanRights: "",
      restriction: "",
      rights: [],
      units: [],
      newType: "",
      category: "Injury",
      incidentCategory: [
        "Abuse/Neglect/Exploitation",
        "Aspiration/Choking",
        "Behavior Intervention",
        "Compromised Environment",
        "Drug/Alcohol",
        "Fatality",
        "Hospital",
        "Injury",
        "Medication Errors",
        "Missing Person",
        "Property Destruction",
        "Seizure",
        "Suicide Attempt/Threat",
        "Theft",
        "Other (describe)",
      ],
      roles: [
        "Family Guardian",
        "Provider Staff",
        "Unknown",
        "Other Client",
        "Support Coordinator",
        "Other (describe)",
      ],
      involvement: [
        "Direct Involvement",
        "Perpetrator",
        "Perpetrator and Victim",
        "Support Coordinator",
        "Victim",
        "Witness Only",
        "Other",
      ],
      organization: [
        "911",
        "APS",
        "Behaviorist",
        "CPS",
        "Dental",
        "Guardian",
        "Hospital",
        "Law Enforcement",
        "Medical Clinic",
        "Natural Supports",
      ],
      location: [
        "Community",
        "Day Program",
        "Home",
        "Place of Employment",
        "Relative's Home",
        "School",
      ],
      calendarMenu: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      newIncidentDateTime: "",
      requiredField: [(v) => !!v || "This is required"],
      calendar2Menu: false,
      newTodaysDate: "",
      newIncidentDiscovered: "",
      program: "",
      newProgram: "",
      newIncidentLocation: "",
      newStreet: "",
      newCity: "",
      newState: "",
      newZipCode: "",
      newIncidentLocationType: "",
      newPersonInvolved1: "",
      newTitle1: "",
      newPhone1: "",
      newRoles1: "",
      newInvolvement1: "",
      newPersonInvolved2: "",
      newTitle2: "",
      newPhone2: "",
      newRoles2: "",
      newInvolvement2: "",
      newPersonInvolved3: "",
      newTitle3: "",
      newPhone3: "",
      newRoles3: "",
      newInvolvement3: "",
      newOrganization1: "",
      newOrgPhone1: "",
      newOrgType1: "",
      newOrgFullName1: "",
      newOrgTitle1: "",
      newOrgNotDate1: "",
      newOrgCaseNum1: "",
      hospital: false,
      newHospitalName: "",
      newHospitalDate: "",
      newFacilityType: "",
      newOtherHospital: "",
      lawEnforcement: false,
      newLaw: "",
      newLawOther: "",
      otherLaw: "",
      medicalCare: false,
      new911Call: "",
      newMedicalClinic: "",
      newER: "",
      newAssessedClient: "",
      newFirstAid: "",
      newPoison: "",
      newNurseContacted: "",
      otherMedical: "",
      newOtherMedical: "",
      newIncidentCategory: [],
      newAbuseCategory: "",
      newAbuseType: "",
      newClientRole: "",
      newProtectiveNotified: "",
      newChokingType: "",
      newChokedItem: "",
      newChokingActions: "",
      newInterventionCircumstances: "",
      newInterventionJustification: "",
      newInterventionCause: "",
      newInterventionDate: "",
      newInterventionDuration: "",
      newFirstIntervention: "",
      newSecondIntervention: "",
      newThirdIntervention: "",
      newFourthIntervention: "",
      newFifthIntervention: "",
      newAdditionalRestraints: "",
      newAdditonalMinutes: "",
      newInterventionUsed: "",
      newOnePerson: "",
      newTwoPerson: "",
      newMultiplePerson: "",
      newFloorRestraint: "",
      newTransportRestraint: "",
      newInterventionPlan: "",
      newBehaviorSpecialist: "",
      newEnvironment: "",
      newEvacuated: "",
      newLocation: "",
      newSubAlcohol: "",
      newSubDrugs: "",
      newSubMedications: "",
      newSubPrescriptions: "",
      newSOther: "",
      newSubOther: "",
      newFatality: "",
      newUnexpected: "",
      newHospice: "",
      newFatalityOther: "",
      newAbdomen: "",
      newBack: "",
      newButtocks: "",
      newChest: "",
      newFace: "",
      newGenitals: "",
      newHead: "",
      newNeck: "",
      newPelvis: "",
      newLeftAnkle: "",
      newLeftArm: "",
      newLeftFoot: "",
      newLeftHand: "",
      newLeftKnee: "",
      newLeftHip: "",
      newLeftLeg: "",
      newLeftShoulder: "",
      newLeftWrist: "",
      newHip: "",
      newRightAnkle: "",
      newRightArm: "",
      newRightFoot: "",
      newRightHand: "",
      newRightKnee: "",
      newRightShoulder: "",
      newRightWrist: "",
      newRightHip: "",
      newInjuredOther: "",
      newOther: "",
      newInjuryRole: "",
      newSelfInflicted: "",
      newMedicationInvolved: "",
      newMedicationError: "",
      newAdverseReaction: "",
      newAdverseDescription: "",
      newMedicationErrOther: "",
      newLastSeen: "",
      newLastLocation: "",
      newDiscovered: "",
      newUnexplained: "",
      newInvoluntary: "",
      newSuspicious: "",
      newFound: "",
      newLivingStatus: "",
      newDamagedItem: "",
      newDamagedPhoto: "",
      newPropertyOwner: "",
      newPropertyAction: "",
      newSeizureDescription: "",
      newSeizureDiagnosis: "",
      newSeizureDuration: "",
      newSuicideType: "",
      newSuicideDescription: "",
      newSuicideActions: "",
      newDetailsOther: "",
      newCircumstances: "",
      newNotified: "",
      newIncidentType: "",
      newIncidentDescription: "",
      newOutcome: "",
      newStaffAssessment: "",
      staffSignature: false,
      newSupervisorName: "",
      newStaffSignature: "",
      newStaffPhone: "",
      supervisorSignature: false,
      newSupervisorSignature: "",
      newSupervisorPhone: "",
      newManagerSignature: "",
      managerSignature: false,
      newDocument: [],
      newSupportCoordinator: "",
      newSupportCoordinatorNotified: "",
      newGuardian: "",
      newGuardianNotified: "",
      newReportReceived: "",
      newReviewedSignature: "",
      reviewedSignature: false,
      newAdminTitle: "",
      newNotificationSubmitted: "",
      newReportSubmitted: "",
      newAdministrativeNotes: "",
      person2: false,
      person3: false,
      newMedicationsInvolved: "",
      itemData: "",
      title: "Confirming...",
      content: "Do you confirm the completion of the ADL?",
      ADLDocumentID: null,
      skinDialog: false,
      isImageRequired: true,
      panel: ""
    };
  },

  computed: {
    ...mapGetters("timezones", ["getUserTimezone", "getDefaultTz"]),

    isBodyCheck(){
        return (serv) => {
          return ['Skin Check', 'General Appearance'].includes(serv.ServiceItem);
      };
    },

    service() {
      const value = 100;

      const adminTime = (serv) => {
        const incomplete =
          serv.filter((item) => item.isSigned).length != serv.length;

        const completed = serv.filter((item) => item.isSigned).length;

        const total = serv.length;

        return {
          incomplete: incomplete,
          completed: completed,
          total: total,
          progress: (value / total) * completed,
        };
      };

      return {
        morning: adminTime(this.morningServices),
        afternoon: adminTime(this.afternoonServices),
        evening: adminTime(this.eveningServices),
        daily: adminTime(this.prnServices),
      };
    },

    sortedServices() {
      const sortTime = (a, b) => {
        // Convert Admintime into 24hrs format and sort
        let aTime = moment(a.newScheduledTime, ["h:mm A"]).format("H");
        let bTime = moment(b.newScheduledTime, ["h:mm A"]).format("H");

        if (parseInt(aTime) < parseInt(bTime)) {
          return -1;
        }
        if (parseInt(aTime) > parseInt(bTime)) {
          return 1;
        }
        return 0;
      };

      return {
        morningMedication: this.morningServices.sort(sortTime),
        afternoonMedications: this.afternoonServices.sort(sortTime),
        eveningMedications: this.eveningServices.sort(sortTime),
        dailyPRNMedications: this.prnServices.sort(sortTime),
      };
    },

    userSignatureTz() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserSignatureTz(data);
    },

    defaultMargin() {
      return this.$vuetify.breakpoint.xsOnly ? "pa-0 my-3" : "pa-3";
    },

    isDisable: {
      get() {
        return this.$store.state.services.isDisableButton;
      },
      set(val) {
        this.$store.commit("services/SET_DISABLE_BUTTON", val);
      },
    },
  },

  watch: {
    sortedServices() {
      return;
    },
  },

  created() {
    this.clientID = this.$route.params.clientID;
    this.$emit("getADL");
  },

  methods: {
    ...mapActions({
      addADL: "services/addADL",
      addMultipleADL: "services/addMultipleADL",
      addShearableLink: "shareLink/addItem",
      viewImages: "adl/viewImages",
    }),

    ...mapMutations({
      setChat: "SET_CHAT",
      setLoading: "services/SET_LOADING",
      setConfirmedDialog: "services/SET_CONFIRMED_DIALOG",
    }),

    async save() {
      this.setConfirmedDialog(false);
      this.isDisable = true;
      let serv = this.itemData;

      var req_body = {
        Service: serv._id,
        Date: serv?.unsignedDate || moment().toDate(),
        Time: serv?.Time || serv.newScheduledTime,
        Assistance: serv.LOA,
        Exception: serv.newException,
        Notes: serv.newNotes,
        Signature: serv.newSignature,
        ClientID: serv.ClientID,
        ADLDocumentID: serv.ADLDocumentID,
        BloodPressure: serv.BloodPressure,
        UrlNotification: this.$router.history.current.path,
        ServiceItem: serv.ServiceItem,
        Type: serv.Type,
        DateSigned: new Date().toString()
      };

      try {
        axios.post(`${url}/adl`, req_body).then((res) => {
          if (res.status == 400) {
            res.json().then(function (data) {
              this.messageDialog(true, "error", data.msg);
            });
          }
          this.newDate = "";
          this.newTime = "";
          this.newAssistance = "";
          this.newException = "";
          this.newNotes = "";
          this.newSignature = "";

          this.messageDialog(
            true,
            "success",
            "The new ADL has been added successfully."
          );

          this.$emit("getADL");
          this.setChat(true);

          //CREATE AUTO ATTENDANCE
          /*
          if(serv.Support === "Yes" && serv.newException === "" ){
            this.addAttendance(serv);
          }
          */
        });
      } catch (error) {
        console.log(error);
      }
    },

    async addADL(serv, index) {
      this.adlImageID = null;

      let isValid = await this.$refs[`${this.panel}Observer`][index].validate();

      console.log(isValid, index)

      if(isValid){
        if (serv.newException !== "Absent") {
          if (
            this.isBodyCheck(serv)
          ) {
            const adlImage = await this.viewAdlImageUploads(serv);
            this.ADLDocumentID = adlImage.data[0]?._id || null;
  
            if (
              this.selectedSkinRequiredItem === "Yes" ||
              !this.selectedSkinRequiredItem
            ) {
              if (adlImage.data.length === 0) {
                return this.messageDialog(
                  true,
                  "red accent-2",
                  `Please add body checks image\\s`
                );
              }
            }
          }
        }
        this.setConfirmedDialog(true);
        this.itemData = { ...serv, ADLDocumentID: this.ADLDocumentID };
      }
    },

    addMultipleItem() {
      this.isSaving = true;
      const ADLfilteredData = this.selectedADL
        .filter((item) => item.active === true)
        .map((serv) => ({
          Service: serv._id,
          Date: moment().toDate(),
          Time: serv.newScheduledTime,
          Assistance: this.newService,
          Exception: this.newException,
          Notes: this.newNotes,
          Signature: this.newSignature,
          ClientID: this.clientID,
        }));

      if (this.error === "") {
        return (this.error = "Signature is required");
      }

      this.addMultipleADL(ADLfilteredData)
        .then((res) => {
          if (res.status !== 200) {
            return;
          }
          this.multipleSelectedItem = false;
          this.selectedADL = [];
          this.$emit("getADL");
        })
        .finally(() => (this.isSaving = false));
    },

    async createShareLink(med) {
      let originUrl = window.location.origin + "/sharing/adl/?code=";
      const data = {
        longUrl: originUrl,
        shortUrl: shareUrl,
        date: new Date(),
        shareUrlInfo: {
          id: med._id,
          time: med.newScheduledTime,
          clientId: med.ClientID,
          img: med.ImageUrl,
        },
      };

      const response = await this.addShearableLink(data);
      this.generatedURL = response.shortUrl;

      this.shareLinkDialog = true;
    },

    selectedItem(data) {
      let index = this.selectedIndex[data.generatedId];

      if (index === undefined) {
        index = this.selectedADL.length;
        this.selectedIndex[data.generatedId] = index;
      }

      this.selectedADL[index] = data;

      this.selectedADL.filter((item) => item.active === true).length >= 2
        ? (this.multipleSelectedItem = true)
        : (this.multipleSelectedItem = false);

      this.setChat(!this.multipleSelectedItem);
    },

    addSignature(serv) {
      if (this.signed) {
        this.newSignature = this.userName + " - " + setUserSignatureTz(this.userSignatureTz);
        this.error = "";
      } else {
        this.newSignature = "";
        this.error = "";
      }

      if (serv.signed) {
        serv.newSignature = this.userName + " - " + setUserSignatureTz(this.userSignatureTz);
        serv.error = "";
      } else {
        serv.newSignature = "";
        serv.error = "";
      }
    },

    readMore(index, item) {
      item.reveal = false;
      this.cardIndex = index;
      this.reveal = true;
    },

    messageDialog(msg, color, text) {
      this.msg = msg;
      this.color = color;
      this.text = text;
    },

    onReveal(item) {
      item.reveal = true;
      this.reveal = false;
    },

    fetchADL() {
      this.$emit("getADL");
    },

    close() {
      this.shareLinkDialog = false;
      this.generatedURL = "";
    },

    openSkinCheckImageUploadDialog(servicePlan) {
      this.$refs.skin.openDialog(servicePlan);
    },

    async openServicePlanAttachmentsDialog(servicePlan) {
      const adlImage = await this.viewAdlImageUploads(servicePlan);
      this.selectedServicePlan = adlImage.data[0] || [];
      this.$refs.attachments.openDialog(this.selectedServicePlan);
    },

    openCreateIncidentReportDialog() {
      this.isOpenCreateIncidentReportDialog = true;
      this.getUnits();
      this.getRights();
    },

    closeCreateIncidentReportDialog() {
      this.isOpenCreateIncidentReportDialog = false;
    },

    selectFiles(files) {
      this.selectedFiles = files;
    },

    selectFollowUpItem(item) {
      this.selectedFollowUpItem = item;
      if (this.selectedFollowUpItem === "Yes") {
        this.isFollowUpDialogOpen = true;
      }
    },

    openFollowUpDialog() {
      this.isFollowUpDialogOpen = true;
    },

    closeFollowUpDialog() {
      this.isFollowUpDialogOpen = false;
    },

    createFollowUpServicePlan() {
      const req_body = {
        ServiceItem: this.selectedServiceItem,
        Type: this.selectedFollowUpType,
        ScheduledTime: this.selectedTimeToBeCompleted,
        Provider: this.selectedFollowUpProvider,
        LOA: this.selectedFollowUpLoa,
        Days: this.selectedFollowUpDays,
        Description: this.followUpDescription,
        StartDate: this.followUpStartDate,
        EndDate: this.followUpEndDate,
        Active: this.selectedFollowUpStatus,
        ClientID: this.clientID,
      };

      axios.post(`${url}/ServicePlans`, req_body).then((res) => {
        this.getServices();
        if (res.status == 400) {
          res.json().then(function (data) {
            this.text = data.msg;
          });
        }
        this.clearFields();
        this.msg = true;
        this.text = "The new service item has been added successfully.";
      });
      this.closeFollowUpDialog();
    },

    getUnits() {
      axios.get(`${url}/units`).then(async (res) => {
        res.data.units.forEach((item) => {
          this.units.push(item.Name);
        });
      });
    },

    getRights() {
      this.isLoading = true;
      axios.get(`${url}/rights/${this.clientID}`).then((res) => {
        this.rights = res.data.rights;
      });
    },

    fileSelected(e) {
      this.uploadFile = e;
    },

    downloadImage(attachment) {
      window.location.href = attachment;
    },

    deleteChip(index) {
      // Prompt here with text if required
      this.newDocument.splice(index, 1);
    },

    addStaffSignature: function () {
      if (this.newStaffSignature == "") {
        this.staffSignature = true;
        this.newStaffSignature = this.staff + " - " + new Date();
      } else {
        this.newStaffSignature = "";
        this.staffSignature = false;
      }
    },

    addManagerSignature() {
      if (this.newManagerSignature == "") {
        this.managerSignature = true;
        this.newManagerSignature = this.staff + " - " + new Date();
      } else {
        this.newManagerSignature = "";
        this.managerSignature = false;
      }
    },

    addReviewedSignature() {
      if (this.newReviewedSignature == "") {
        this.reviewedSignature = true;
        this.newReviewedSignature = this.staff + " - " + new Date();
      } else {
        this.newReviewedSignature = "";
        this.reviewedSignature = false;
      }
    },

    validate() {
      return this.$refs.form.validate();
    },

    addIncidentReport() {
      if (this.validate()) {
        let payload = {
          Type: this.newType,
          IncidentDateTime: this.newIncidentDateTime,
          TodaysDate: this.newTodaysDate,
          IncidentDiscovered: this.newIncidentDiscovered,
          Street: this.newStreet,
          City: this.newCity,
          State: this.newState,
          ZipCode: this.newZipCode,
          Program: this.newProgram,
          IncidentLocation: this.newIncidentLocation,
          IncidentLocationType: this.newIncidentLocationType,
          PersonInvolved1: this.newPersonInvolved1,
          Title1: this.newTitle1,
          Phone1: this.newPhone1,
          Roles1: this.newRoles1,
          Involvement1: this.newInvolvement1,
          PersonInvolved2: this.newPersonInvolved2,
          Title2: this.newTitle2,
          Phone2: this.newPhone2,
          Roles2: this.newRoles2,
          Involvement2: this.newInvolvement2,
          PersonInvolved3: this.newPersonInvolved3,
          Title3: this.newTitle3,
          Phone3: this.newPhone3,
          Roles3: this.newRoles3,
          Involvement3: this.newInvolvement3,
          Organization1: this.newOrganization1,
          OrgPhone1: this.newOrgPhone1,
          OrgType1: this.newOrgType1,
          OrgFullName1: this.newOrgFullName1,
          OrgTitle1: this.newOrgTitle1,
          OrgNotDate1: this.newOrgNotDate1,
          OrgCaseNum1: this.newOrgCaseNum1,
          Hospital: this.hospital,
          HospitalName: this.newHospitalName,
          HospitalDate: this.newHospitalDate,
          FacilityType: this.newFacilityType,
          OtherHospital: this.newOtherHospital,
          LawEnforcement: this.lawEnforcement,
          Law: this.newLaw,
          OtherLaw: this.newLawOther,
          MedicalCare: this.medicalCare,
          Call: this.new911Call,
          MedicalClinic: this.newMedicalClinic,
          ER: this.newER,
          AssessedClient: this.newAssessedClient,
          FirstAid: this.newFirstAid,
          Poison: this.newPoison,
          NurseContacted: this.newNurseContacted,
          OtherMedical: this.newOtherMedical,
          Involved: this.newInvolved,
          IncidentCategory: this.newIncidentCategory,
          AbuseType: this.newAbuseType,
          ClientRole: this.newClientRole,
          ProtectiveNotified: this.newProtectiveNotified,
          ChokingType: this.newChokingType,
          ChokedItem: this.newChokedItem,
          ChokingActions: this.newChokingActions,
          InterventionCircumstances: this.newInterventionCircumstances,
          InterventionJustification: this.newInterventionJustification,
          InterventionCause: this.newInterventionCause,
          InterventionDate: this.newInterventionDate,
          InterventionDuration: this.newInterventionDuration,
          FirstIntervention: this.newFirstIntervention,
          SecondIntervention: this.newSecondIntervention,
          ThirdIntervention: this.newThirdIntervention,
          FourthIntervention: this.newFourthIntervention,
          FifthIntervention: this.newFifthIntervention,
          AdditionalRestraints: this.newAdditionalRestraints,
          AdditionalMinutes: this.newAdditionalMinutes,
          InterventionUsed: this.newInterventionUsed,
          OnePerson: this.newOnePerson,
          TwoPerson: this.newTwoPerson,
          MultiplePerson: this.newMultiplePerson,
          FloorRestraint: this.newFloorRestraint,
          TransportRestraint: this.newTransportRestraint,
          InterventionPlan: this.newInterventionPlan,
          BehaviorSpecialist: this.newBehaviorSpecialist,
          Environment: this.newEnvironment,
          Evacuated: this.newEvacuated,
          Location: this.newLocation,
          SubAlcohol: this.newSubAlcohol,
          SubDrugs: this.newSubDrugs,
          SubMedications: this.newSubMedications,
          SubPrescriptions: this.newSubPrescriptions,
          SubOther: this.newSubOther,
          Fatality: this.newFatality,
          Unexpected: this.newUnexpected,
          Hospice: this.newHospice,
          FatalityOther: this.newFatalityOther,
          Adbomen: this.newAbdomen,
          Back: this.newBack,
          Buttocks: this.newButtocks,
          Chest: this.newChest,
          Face: this.newFace,
          Genitals: this.newGenitals,
          Head: this.newHead,
          Neck: this.newNeck,
          Pelvis: this.newPelvis,
          LeftAnkle: this.newLeftAnkle,
          LeftArm: this.newLeftArm,
          LeftFoot: this.newLeftFoot,
          LeftHand: this.newLeftHand,
          LeftKnee: this.newLeftKnee,
          LeftLeg: this.newLeftLeg,
          LeftShoulder: this.newLeftShoulder,
          LeftWrist: this.newLeftWrist,
          LeftHip: this.newLeftHip,
          RightAnkle: this.newRightAnkle,
          RightArm: this.newRightArm,
          RightFoot: this.newRightFoot,
          RightHand: this.newRightHand,
          RightKnee: this.newRightKnee,
          RightShoulder: this.newRightShoulder,
          RightWrist: this.newRightWrist,
          RightHip: this.newRightHip,
          InjuredOther: this.newInjuredOther,
          InjuryRole: this.newInjuryRole,
          SelfInflicted: this.newSelfInflicted,
          MedicationInvolved: this.newMedicationInvolved,
          MedicationError: this.newMedicationError,
          AdverseReaction: this.newAdverseReaction,
          AdverseDescription: this.newAdverseDescription,
          MedicationErrOther: this.newMedicationErrOther,
          LastSeen: this.newLastSeen,
          LastLocation: this.newLastLocation,
          Discovered: this.newDiscovered,
          Unexplained: this.newUnexplained,
          Involuntary: this.newInvoluntary,
          Suspicious: this.newSuspicious,
          Found: this.newFound,
          LivingStatus: this.newLivingStatus,
          DamagedItem: this.newDamagedItem,
          DamagedPhoto: this.newDamagedPhoto,
          PropertyOwner: this.newPropertyOwner,
          PropertyAction: this.newPropertyAction,
          SeizureDescription: this.newSeizureDescription,
          SeizureDiagnosis: this.newSeizureDiagnosis,
          SeizureStart: this.newSeizureStart,
          SeizureDuration: this.newSeizureDuration,
          SuicideType: this.newSuicideType,
          SuicideDescription: this.newSuicideDescription,
          SuicideActions: this.newSuicideActions,
          DetailsOther: this.newDeatilsOther,
          Circumstances: this.newCircumstances,
          Notified: this.newNotified,
          IncidentType: this.newIncidentType,
          IncidentDescription: this.newIncidentDescription,
          Outcome: this.newOutcome,
          StaffAssessment: this.newStaffAssessment,
          StaffSignature: this.newStaffSignature,
          StaffPhone: this.newStaffPhone,
          SupervisorName: this.newSupervisorName,
          Document: this.Document,
          SupportCoordinator: this.newSupportCoordinator,
          SupervisorSignature: this.newSupervisorSignature,
          SupervisorPhone: this.newSupervisorPhone,
          ReportReceived: this.newReportReceived,
          ReviewedBy: this.newReviewedBy,
          AdminTitle: this.newAdminTitle,
          AdministrativeNotes: this.newAdministrativeNotes,
          ClientID: this.clientID,
        };

        const addIncidentUrl = `${url}/incidents`;

        axios.post(addIncidentUrl, payload).then((response) => {
          this.incidentID = response.data._id;
          if (this.uploadFile !== null && this.uploadFile !== undefined) {
            this.saveFile();
          }

          if (this.damagedPhotos && this.damagedPhotos.length) {
            this.uploadDamagedPhotos(this.damagedPhotos);
          }

          this.getIncidents();
          this.msg = true;
          this.text = "A new incident has been added successfully.";
        });
        this.close();
      }
    },

    async addAttendance(data) {
      try {
        var req_body = {
          Signature: data.newSignature,
          ClientID: data.ClientID,
          SupportStrategyID: data.SupportStrategy,
          Date: moment(this.date).format("YYYY-MM-DD"),
        };
        await axios
          .post(`${url}/attendance/autoCreate`, req_body)
          .then((res) => {
            console.log(res);
          });
      } catch (error) {
        console.log(error);
      }
    },

    async viewAdlImageUploads(serv) {
      const data = {
        service_id: serv._id,
        scheduleTime: serv.scheduleTime,
        date: new Date(),
        clientID: this.clientID,
        tz: this.getDefaultTz,
      };
      let adlImage = await this.viewImages(data);

      return adlImage;
    },

    selectCheckItem(val) {
      if (val === "No") this.skinDialog = true;
    },

    closeDialog(val) {
      this.skinDialog = false;
      if (val) {
        this.selectedSkinRequiredItem = "Yes";
      } else {
        this.selectedSkinRequiredItem = "No";
      }
    },
    handleChangePanel(panel){
      console.log({panel})
      this.panel = panel
    }
  },
};
</script>

<style scoped>
.v-expansion-panel--active
  > .v-expansion-panel-header--active
  .v-expansion-panel-header__icon:not(
    .v-expansion-panel-header__icon--disable-rotate
  )
  .v-icon {
  transform: none !important;
}

.panel-header {
  min-height: 100px;
}

.fab-multiple {
  z-index: 999;
}

.adl-image {
  width: 100%;
  height: 250px;
  background-size: contain;
}

.overlay-fade {
  position: relative;
  box-sizing: border-box;
  height: 250px;
  width: 100%;
  overflow: hidden;
  float: left;
  margin: 10px;
}

.overlay-fade div {
  position: absolute;
  box-sizing: border-box;
  top: 0;
  background: rgb(0, 3, 28);
  background: linear-gradient(
    0deg,
    rgba(0, 3, 28, 1) 37%,
    rgba(133, 134, 146, 1) 54%,
    rgba(255, 255, 255, 1) 100%
  );
  width: 100%;
  height: 250px;
  opacity: 0.5;
  transition: all 0.2s ease-in;
}

.schedule-time {
  position: absolute;
  right: 0;
  margin-right: 10px;
  margin-top: 10px;
  z-index: 2;
}

.btn-image-upload {
  position: absolute;
  right: 0;
  margin-right: 9px;
  margin-top: 45px;
  z-index: 2;
}

.btn-follow-up {
  position: absolute;
  width: 55%;
  right: 0;
  margin-right: 9px;
  margin-top: 120px;
  z-index: 2;
  padding-top: 40px;
}

.btn-incident-report {
  position: absolute;
  width: 55%;
  right: 0;
  margin-right: 9px;
  margin-top: 180px;
  z-index: 2;
}

.btn-view-image {
  position: absolute;
  width: 50%;
  right: 0;
  margin-right: 9px;
  margin-top: 80px;
  z-index: 2;
}

.shared-link {
  position: absolute;
  right: 0;
  bottom: 0;
  margin-bottom: 10px;
  z-index: 2;
}

.img-container {
  position: relative;
}

.description {
  bottom: -10px;
  position: absolute;
  color: white;
}
</style>
